"use strict";
const holidays = {
    "1970-01-01": {
        date: "1970-01-01",
        week: "木",
        week_en: "Thursday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "1970-01-15": {
        date: "1970-01-15",
        week: "木",
        week_en: "Thursday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "1970-02-11": {
        date: "1970-02-11",
        week: "水",
        week_en: "Wednesday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "1970-03-21": {
        date: "1970-03-21",
        week: "土",
        week_en: "Saturday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "1970-04-29": {
        date: "1970-04-29",
        week: "水",
        week_en: "Wednesday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "1970-05-03": {
        date: "1970-05-03",
        week: "日",
        week_en: "Sunday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "1970-05-05": {
        date: "1970-05-05",
        week: "火",
        week_en: "Tuesday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "1970-09-15": {
        date: "1970-09-15",
        week: "火",
        week_en: "Tuesday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "1970-09-23": {
        date: "1970-09-23",
        week: "水",
        week_en: "Wednesday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "1970-10-10": {
        date: "1970-10-10",
        week: "土",
        week_en: "Saturday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "1970-11-03": {
        date: "1970-11-03",
        week: "火",
        week_en: "Tuesday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "1970-11-23": {
        date: "1970-11-23",
        week: "月",
        week_en: "Monday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "1971-01-01": {
        date: "1971-01-01",
        week: "金",
        week_en: "Friday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "1971-01-15": {
        date: "1971-01-15",
        week: "金",
        week_en: "Friday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "1971-02-11": {
        date: "1971-02-11",
        week: "木",
        week_en: "Thursday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "1971-03-21": {
        date: "1971-03-21",
        week: "日",
        week_en: "Sunday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "1971-04-29": {
        date: "1971-04-29",
        week: "木",
        week_en: "Thursday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "1971-05-03": {
        date: "1971-05-03",
        week: "月",
        week_en: "Monday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "1971-05-05": {
        date: "1971-05-05",
        week: "水",
        week_en: "Wednesday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "1971-09-15": {
        date: "1971-09-15",
        week: "水",
        week_en: "Wednesday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "1971-09-24": {
        date: "1971-09-24",
        week: "金",
        week_en: "Friday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "1971-10-10": {
        date: "1971-10-10",
        week: "日",
        week_en: "Sunday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "1971-11-03": {
        date: "1971-11-03",
        week: "水",
        week_en: "Wednesday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "1971-11-23": {
        date: "1971-11-23",
        week: "火",
        week_en: "Tuesday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "1972-01-01": {
        date: "1972-01-01",
        week: "土",
        week_en: "Saturday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "1972-01-15": {
        date: "1972-01-15",
        week: "土",
        week_en: "Saturday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "1972-02-11": {
        date: "1972-02-11",
        week: "金",
        week_en: "Friday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "1972-03-20": {
        date: "1972-03-20",
        week: "月",
        week_en: "Monday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "1972-04-29": {
        date: "1972-04-29",
        week: "土",
        week_en: "Saturday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "1972-05-03": {
        date: "1972-05-03",
        week: "水",
        week_en: "Wednesday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "1972-05-05": {
        date: "1972-05-05",
        week: "金",
        week_en: "Friday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "1972-09-15": {
        date: "1972-09-15",
        week: "金",
        week_en: "Friday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "1972-09-23": {
        date: "1972-09-23",
        week: "土",
        week_en: "Saturday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "1972-10-10": {
        date: "1972-10-10",
        week: "火",
        week_en: "Tuesday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "1972-11-03": {
        date: "1972-11-03",
        week: "金",
        week_en: "Friday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "1972-11-23": {
        date: "1972-11-23",
        week: "木",
        week_en: "Thursday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "1973-01-01": {
        date: "1973-01-01",
        week: "月",
        week_en: "Monday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "1973-01-15": {
        date: "1973-01-15",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "1973-02-11": {
        date: "1973-02-11",
        week: "日",
        week_en: "Sunday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "1973-03-21": {
        date: "1973-03-21",
        week: "水",
        week_en: "Wednesday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "1973-04-29": {
        date: "1973-04-29",
        week: "日",
        week_en: "Sunday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "1973-04-30": {
        date: "1973-04-30",
        week: "月",
        week_en: "Monday",
        name: "天皇誕生日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1973-05-03": {
        date: "1973-05-03",
        week: "木",
        week_en: "Thursday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "1973-05-05": {
        date: "1973-05-05",
        week: "土",
        week_en: "Saturday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "1973-09-15": {
        date: "1973-09-15",
        week: "土",
        week_en: "Saturday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "1973-09-23": {
        date: "1973-09-23",
        week: "日",
        week_en: "Sunday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "1973-09-24": {
        date: "1973-09-24",
        week: "月",
        week_en: "Monday",
        name: "秋分の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1973-10-10": {
        date: "1973-10-10",
        week: "水",
        week_en: "Wednesday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "1973-11-03": {
        date: "1973-11-03",
        week: "土",
        week_en: "Saturday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "1973-11-23": {
        date: "1973-11-23",
        week: "金",
        week_en: "Friday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "1974-01-01": {
        date: "1974-01-01",
        week: "火",
        week_en: "Tuesday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "1974-01-15": {
        date: "1974-01-15",
        week: "火",
        week_en: "Tuesday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "1974-02-11": {
        date: "1974-02-11",
        week: "月",
        week_en: "Monday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "1974-03-21": {
        date: "1974-03-21",
        week: "木",
        week_en: "Thursday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "1974-04-29": {
        date: "1974-04-29",
        week: "月",
        week_en: "Monday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "1974-05-03": {
        date: "1974-05-03",
        week: "金",
        week_en: "Friday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "1974-05-05": {
        date: "1974-05-05",
        week: "日",
        week_en: "Sunday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "1974-05-06": {
        date: "1974-05-06",
        week: "月",
        week_en: "Monday",
        name: "こどもの日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1974-09-15": {
        date: "1974-09-15",
        week: "日",
        week_en: "Sunday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "1974-09-16": {
        date: "1974-09-16",
        week: "月",
        week_en: "Monday",
        name: "敬老の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1974-09-23": {
        date: "1974-09-23",
        week: "月",
        week_en: "Monday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "1974-10-10": {
        date: "1974-10-10",
        week: "木",
        week_en: "Thursday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "1974-11-03": {
        date: "1974-11-03",
        week: "日",
        week_en: "Sunday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "1974-11-04": {
        date: "1974-11-04",
        week: "月",
        week_en: "Monday",
        name: "文化の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1974-11-23": {
        date: "1974-11-23",
        week: "土",
        week_en: "Saturday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "1975-01-01": {
        date: "1975-01-01",
        week: "水",
        week_en: "Wednesday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "1975-01-15": {
        date: "1975-01-15",
        week: "水",
        week_en: "Wednesday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "1975-02-11": {
        date: "1975-02-11",
        week: "火",
        week_en: "Tuesday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "1975-03-21": {
        date: "1975-03-21",
        week: "金",
        week_en: "Friday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "1975-04-29": {
        date: "1975-04-29",
        week: "火",
        week_en: "Tuesday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "1975-05-03": {
        date: "1975-05-03",
        week: "土",
        week_en: "Saturday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "1975-05-05": {
        date: "1975-05-05",
        week: "月",
        week_en: "Monday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "1975-09-15": {
        date: "1975-09-15",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "1975-09-24": {
        date: "1975-09-24",
        week: "水",
        week_en: "Wednesday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "1975-10-10": {
        date: "1975-10-10",
        week: "金",
        week_en: "Friday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "1975-11-03": {
        date: "1975-11-03",
        week: "月",
        week_en: "Monday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "1975-11-23": {
        date: "1975-11-23",
        week: "日",
        week_en: "Sunday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "1975-11-24": {
        date: "1975-11-24",
        week: "月",
        week_en: "Monday",
        name: "勤労感謝の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1976-01-01": {
        date: "1976-01-01",
        week: "木",
        week_en: "Thursday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "1976-01-15": {
        date: "1976-01-15",
        week: "木",
        week_en: "Thursday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "1976-02-11": {
        date: "1976-02-11",
        week: "水",
        week_en: "Wednesday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "1976-03-20": {
        date: "1976-03-20",
        week: "土",
        week_en: "Saturday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "1976-04-29": {
        date: "1976-04-29",
        week: "木",
        week_en: "Thursday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "1976-05-03": {
        date: "1976-05-03",
        week: "月",
        week_en: "Monday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "1976-05-05": {
        date: "1976-05-05",
        week: "水",
        week_en: "Wednesday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "1976-09-15": {
        date: "1976-09-15",
        week: "水",
        week_en: "Wednesday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "1976-09-23": {
        date: "1976-09-23",
        week: "木",
        week_en: "Thursday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "1976-10-10": {
        date: "1976-10-10",
        week: "日",
        week_en: "Sunday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "1976-10-11": {
        date: "1976-10-11",
        week: "月",
        week_en: "Monday",
        name: "体育の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1976-11-03": {
        date: "1976-11-03",
        week: "水",
        week_en: "Wednesday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "1976-11-23": {
        date: "1976-11-23",
        week: "火",
        week_en: "Tuesday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "1977-01-01": {
        date: "1977-01-01",
        week: "土",
        week_en: "Saturday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "1977-01-15": {
        date: "1977-01-15",
        week: "土",
        week_en: "Saturday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "1977-02-11": {
        date: "1977-02-11",
        week: "金",
        week_en: "Friday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "1977-03-21": {
        date: "1977-03-21",
        week: "月",
        week_en: "Monday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "1977-04-29": {
        date: "1977-04-29",
        week: "金",
        week_en: "Friday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "1977-05-03": {
        date: "1977-05-03",
        week: "火",
        week_en: "Tuesday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "1977-05-05": {
        date: "1977-05-05",
        week: "木",
        week_en: "Thursday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "1977-09-15": {
        date: "1977-09-15",
        week: "木",
        week_en: "Thursday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "1977-09-23": {
        date: "1977-09-23",
        week: "金",
        week_en: "Friday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "1977-10-10": {
        date: "1977-10-10",
        week: "月",
        week_en: "Monday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "1977-11-03": {
        date: "1977-11-03",
        week: "木",
        week_en: "Thursday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "1977-11-23": {
        date: "1977-11-23",
        week: "水",
        week_en: "Wednesday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "1978-01-01": {
        date: "1978-01-01",
        week: "日",
        week_en: "Sunday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "1978-01-02": {
        date: "1978-01-02",
        week: "月",
        week_en: "Monday",
        name: "元日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1978-01-15": {
        date: "1978-01-15",
        week: "日",
        week_en: "Sunday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "1978-01-16": {
        date: "1978-01-16",
        week: "月",
        week_en: "Monday",
        name: "成人の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1978-02-11": {
        date: "1978-02-11",
        week: "土",
        week_en: "Saturday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "1978-03-21": {
        date: "1978-03-21",
        week: "火",
        week_en: "Tuesday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "1978-04-29": {
        date: "1978-04-29",
        week: "土",
        week_en: "Saturday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "1978-05-03": {
        date: "1978-05-03",
        week: "水",
        week_en: "Wednesday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "1978-05-05": {
        date: "1978-05-05",
        week: "金",
        week_en: "Friday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "1978-09-15": {
        date: "1978-09-15",
        week: "金",
        week_en: "Friday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "1978-09-23": {
        date: "1978-09-23",
        week: "土",
        week_en: "Saturday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "1978-10-10": {
        date: "1978-10-10",
        week: "火",
        week_en: "Tuesday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "1978-11-03": {
        date: "1978-11-03",
        week: "金",
        week_en: "Friday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "1978-11-23": {
        date: "1978-11-23",
        week: "木",
        week_en: "Thursday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "1979-01-01": {
        date: "1979-01-01",
        week: "月",
        week_en: "Monday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "1979-01-15": {
        date: "1979-01-15",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "1979-02-11": {
        date: "1979-02-11",
        week: "日",
        week_en: "Sunday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "1979-02-12": {
        date: "1979-02-12",
        week: "月",
        week_en: "Monday",
        name: "建国記念の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1979-03-21": {
        date: "1979-03-21",
        week: "水",
        week_en: "Wednesday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "1979-04-29": {
        date: "1979-04-29",
        week: "日",
        week_en: "Sunday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "1979-04-30": {
        date: "1979-04-30",
        week: "月",
        week_en: "Monday",
        name: "天皇誕生日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1979-05-03": {
        date: "1979-05-03",
        week: "木",
        week_en: "Thursday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "1979-05-05": {
        date: "1979-05-05",
        week: "土",
        week_en: "Saturday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "1979-09-15": {
        date: "1979-09-15",
        week: "土",
        week_en: "Saturday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "1979-09-24": {
        date: "1979-09-24",
        week: "月",
        week_en: "Monday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "1979-10-10": {
        date: "1979-10-10",
        week: "水",
        week_en: "Wednesday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "1979-11-03": {
        date: "1979-11-03",
        week: "土",
        week_en: "Saturday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "1979-11-23": {
        date: "1979-11-23",
        week: "金",
        week_en: "Friday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "1980-01-01": {
        date: "1980-01-01",
        week: "火",
        week_en: "Tuesday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "1980-01-15": {
        date: "1980-01-15",
        week: "火",
        week_en: "Tuesday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "1980-02-11": {
        date: "1980-02-11",
        week: "月",
        week_en: "Monday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "1980-03-20": {
        date: "1980-03-20",
        week: "木",
        week_en: "Thursday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "1980-04-29": {
        date: "1980-04-29",
        week: "火",
        week_en: "Tuesday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "1980-05-03": {
        date: "1980-05-03",
        week: "土",
        week_en: "Saturday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "1980-05-05": {
        date: "1980-05-05",
        week: "月",
        week_en: "Monday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "1980-09-15": {
        date: "1980-09-15",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "1980-09-23": {
        date: "1980-09-23",
        week: "火",
        week_en: "Tuesday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "1980-10-10": {
        date: "1980-10-10",
        week: "金",
        week_en: "Friday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "1980-11-03": {
        date: "1980-11-03",
        week: "月",
        week_en: "Monday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "1980-11-23": {
        date: "1980-11-23",
        week: "日",
        week_en: "Sunday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "1980-11-24": {
        date: "1980-11-24",
        week: "月",
        week_en: "Monday",
        name: "勤労感謝の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1981-01-01": {
        date: "1981-01-01",
        week: "木",
        week_en: "Thursday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "1981-01-15": {
        date: "1981-01-15",
        week: "木",
        week_en: "Thursday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "1981-02-11": {
        date: "1981-02-11",
        week: "水",
        week_en: "Wednesday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "1981-03-21": {
        date: "1981-03-21",
        week: "土",
        week_en: "Saturday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "1981-04-29": {
        date: "1981-04-29",
        week: "水",
        week_en: "Wednesday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "1981-05-03": {
        date: "1981-05-03",
        week: "日",
        week_en: "Sunday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "1981-05-04": {
        date: "1981-05-04",
        week: "月",
        week_en: "Monday",
        name: "憲法記念日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1981-05-05": {
        date: "1981-05-05",
        week: "火",
        week_en: "Tuesday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "1981-09-15": {
        date: "1981-09-15",
        week: "火",
        week_en: "Tuesday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "1981-09-23": {
        date: "1981-09-23",
        week: "水",
        week_en: "Wednesday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "1981-10-10": {
        date: "1981-10-10",
        week: "土",
        week_en: "Saturday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "1981-11-03": {
        date: "1981-11-03",
        week: "火",
        week_en: "Tuesday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "1981-11-23": {
        date: "1981-11-23",
        week: "月",
        week_en: "Monday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "1982-01-01": {
        date: "1982-01-01",
        week: "金",
        week_en: "Friday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "1982-01-15": {
        date: "1982-01-15",
        week: "金",
        week_en: "Friday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "1982-02-11": {
        date: "1982-02-11",
        week: "木",
        week_en: "Thursday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "1982-03-21": {
        date: "1982-03-21",
        week: "日",
        week_en: "Sunday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "1982-03-22": {
        date: "1982-03-22",
        week: "月",
        week_en: "Monday",
        name: "春分の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1982-04-29": {
        date: "1982-04-29",
        week: "木",
        week_en: "Thursday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "1982-05-03": {
        date: "1982-05-03",
        week: "月",
        week_en: "Monday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "1982-05-05": {
        date: "1982-05-05",
        week: "水",
        week_en: "Wednesday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "1982-09-15": {
        date: "1982-09-15",
        week: "水",
        week_en: "Wednesday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "1982-09-23": {
        date: "1982-09-23",
        week: "木",
        week_en: "Thursday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "1982-10-10": {
        date: "1982-10-10",
        week: "日",
        week_en: "Sunday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "1982-10-11": {
        date: "1982-10-11",
        week: "月",
        week_en: "Monday",
        name: "体育の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1982-11-03": {
        date: "1982-11-03",
        week: "水",
        week_en: "Wednesday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "1982-11-23": {
        date: "1982-11-23",
        week: "火",
        week_en: "Tuesday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "1983-01-01": {
        date: "1983-01-01",
        week: "土",
        week_en: "Saturday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "1983-01-15": {
        date: "1983-01-15",
        week: "土",
        week_en: "Saturday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "1983-02-11": {
        date: "1983-02-11",
        week: "金",
        week_en: "Friday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "1983-03-21": {
        date: "1983-03-21",
        week: "月",
        week_en: "Monday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "1983-04-29": {
        date: "1983-04-29",
        week: "金",
        week_en: "Friday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "1983-05-03": {
        date: "1983-05-03",
        week: "火",
        week_en: "Tuesday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "1983-05-05": {
        date: "1983-05-05",
        week: "木",
        week_en: "Thursday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "1983-09-15": {
        date: "1983-09-15",
        week: "木",
        week_en: "Thursday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "1983-09-23": {
        date: "1983-09-23",
        week: "金",
        week_en: "Friday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "1983-10-10": {
        date: "1983-10-10",
        week: "月",
        week_en: "Monday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "1983-11-03": {
        date: "1983-11-03",
        week: "木",
        week_en: "Thursday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "1983-11-23": {
        date: "1983-11-23",
        week: "水",
        week_en: "Wednesday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "1984-01-01": {
        date: "1984-01-01",
        week: "日",
        week_en: "Sunday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "1984-01-02": {
        date: "1984-01-02",
        week: "月",
        week_en: "Monday",
        name: "元日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1984-01-15": {
        date: "1984-01-15",
        week: "日",
        week_en: "Sunday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "1984-01-16": {
        date: "1984-01-16",
        week: "月",
        week_en: "Monday",
        name: "成人の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1984-02-11": {
        date: "1984-02-11",
        week: "土",
        week_en: "Saturday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "1984-03-20": {
        date: "1984-03-20",
        week: "火",
        week_en: "Tuesday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "1984-04-29": {
        date: "1984-04-29",
        week: "日",
        week_en: "Sunday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "1984-04-30": {
        date: "1984-04-30",
        week: "月",
        week_en: "Monday",
        name: "天皇誕生日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1984-05-03": {
        date: "1984-05-03",
        week: "木",
        week_en: "Thursday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "1984-05-05": {
        date: "1984-05-05",
        week: "土",
        week_en: "Saturday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "1984-09-15": {
        date: "1984-09-15",
        week: "土",
        week_en: "Saturday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "1984-09-23": {
        date: "1984-09-23",
        week: "日",
        week_en: "Sunday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "1984-09-24": {
        date: "1984-09-24",
        week: "月",
        week_en: "Monday",
        name: "秋分の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1984-10-10": {
        date: "1984-10-10",
        week: "水",
        week_en: "Wednesday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "1984-11-03": {
        date: "1984-11-03",
        week: "土",
        week_en: "Saturday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "1984-11-23": {
        date: "1984-11-23",
        week: "金",
        week_en: "Friday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "1985-01-01": {
        date: "1985-01-01",
        week: "火",
        week_en: "Tuesday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "1985-01-15": {
        date: "1985-01-15",
        week: "火",
        week_en: "Tuesday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "1985-02-11": {
        date: "1985-02-11",
        week: "月",
        week_en: "Monday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "1985-03-21": {
        date: "1985-03-21",
        week: "木",
        week_en: "Thursday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "1985-04-29": {
        date: "1985-04-29",
        week: "月",
        week_en: "Monday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "1985-05-03": {
        date: "1985-05-03",
        week: "金",
        week_en: "Friday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "1985-05-05": {
        date: "1985-05-05",
        week: "日",
        week_en: "Sunday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "1985-05-06": {
        date: "1985-05-06",
        week: "月",
        week_en: "Monday",
        name: "こどもの日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1985-09-15": {
        date: "1985-09-15",
        week: "日",
        week_en: "Sunday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "1985-09-16": {
        date: "1985-09-16",
        week: "月",
        week_en: "Monday",
        name: "敬老の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1985-09-23": {
        date: "1985-09-23",
        week: "月",
        week_en: "Monday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "1985-10-10": {
        date: "1985-10-10",
        week: "木",
        week_en: "Thursday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "1985-11-03": {
        date: "1985-11-03",
        week: "日",
        week_en: "Sunday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "1985-11-04": {
        date: "1985-11-04",
        week: "月",
        week_en: "Monday",
        name: "文化の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1985-11-23": {
        date: "1985-11-23",
        week: "土",
        week_en: "Saturday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "1986-01-01": {
        date: "1986-01-01",
        week: "水",
        week_en: "Wednesday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "1986-01-15": {
        date: "1986-01-15",
        week: "水",
        week_en: "Wednesday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "1986-02-11": {
        date: "1986-02-11",
        week: "火",
        week_en: "Tuesday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "1986-03-21": {
        date: "1986-03-21",
        week: "金",
        week_en: "Friday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "1986-04-29": {
        date: "1986-04-29",
        week: "火",
        week_en: "Tuesday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "1986-05-03": {
        date: "1986-05-03",
        week: "土",
        week_en: "Saturday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "1986-05-05": {
        date: "1986-05-05",
        week: "月",
        week_en: "Monday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "1986-09-15": {
        date: "1986-09-15",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "1986-09-23": {
        date: "1986-09-23",
        week: "火",
        week_en: "Tuesday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "1986-10-10": {
        date: "1986-10-10",
        week: "金",
        week_en: "Friday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "1986-11-03": {
        date: "1986-11-03",
        week: "月",
        week_en: "Monday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "1986-11-23": {
        date: "1986-11-23",
        week: "日",
        week_en: "Sunday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "1986-11-24": {
        date: "1986-11-24",
        week: "月",
        week_en: "Monday",
        name: "勤労感謝の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1987-01-01": {
        date: "1987-01-01",
        week: "木",
        week_en: "Thursday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "1987-01-15": {
        date: "1987-01-15",
        week: "木",
        week_en: "Thursday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "1987-02-11": {
        date: "1987-02-11",
        week: "水",
        week_en: "Wednesday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "1987-03-21": {
        date: "1987-03-21",
        week: "土",
        week_en: "Saturday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "1987-04-29": {
        date: "1987-04-29",
        week: "水",
        week_en: "Wednesday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "1987-05-03": {
        date: "1987-05-03",
        week: "日",
        week_en: "Sunday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "1987-05-04": {
        date: "1987-05-04",
        week: "月",
        week_en: "Monday",
        name: "憲法記念日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1987-05-05": {
        date: "1987-05-05",
        week: "火",
        week_en: "Tuesday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "1987-09-15": {
        date: "1987-09-15",
        week: "火",
        week_en: "Tuesday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "1987-09-23": {
        date: "1987-09-23",
        week: "水",
        week_en: "Wednesday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "1987-10-10": {
        date: "1987-10-10",
        week: "土",
        week_en: "Saturday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "1987-11-03": {
        date: "1987-11-03",
        week: "火",
        week_en: "Tuesday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "1987-11-23": {
        date: "1987-11-23",
        week: "月",
        week_en: "Monday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "1988-01-01": {
        date: "1988-01-01",
        week: "金",
        week_en: "Friday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "1988-01-15": {
        date: "1988-01-15",
        week: "金",
        week_en: "Friday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "1988-02-11": {
        date: "1988-02-11",
        week: "木",
        week_en: "Thursday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "1988-03-20": {
        date: "1988-03-20",
        week: "日",
        week_en: "Sunday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "1988-03-21": {
        date: "1988-03-21",
        week: "月",
        week_en: "Monday",
        name: "春分の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1988-04-29": {
        date: "1988-04-29",
        week: "金",
        week_en: "Friday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "1988-05-03": {
        date: "1988-05-03",
        week: "火",
        week_en: "Tuesday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "1988-05-04": {
        date: "1988-05-04",
        week: "水",
        week_en: "Wednesday",
        name: "休日",
        name_en: "Citizen's Holiday"
    },
    "1988-05-05": {
        date: "1988-05-05",
        week: "木",
        week_en: "Thursday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "1988-09-15": {
        date: "1988-09-15",
        week: "木",
        week_en: "Thursday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "1988-09-23": {
        date: "1988-09-23",
        week: "金",
        week_en: "Friday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "1988-10-10": {
        date: "1988-10-10",
        week: "月",
        week_en: "Monday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "1988-11-03": {
        date: "1988-11-03",
        week: "木",
        week_en: "Thursday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "1988-11-23": {
        date: "1988-11-23",
        week: "水",
        week_en: "Wednesday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "1989-01-01": {
        date: "1989-01-01",
        week: "日",
        week_en: "Sunday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "1989-01-02": {
        date: "1989-01-02",
        week: "月",
        week_en: "Monday",
        name: "元日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1989-01-15": {
        date: "1989-01-15",
        week: "日",
        week_en: "Sunday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "1989-01-16": {
        date: "1989-01-16",
        week: "月",
        week_en: "Monday",
        name: "成人の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1989-02-11": {
        date: "1989-02-11",
        week: "土",
        week_en: "Saturday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "1989-02-24": {
        date: "1989-02-24",
        week: "金",
        week_en: "Friday",
        name: "大喪の礼",
        name_en: "The Funeral Ceremony of Emperor Showa."
    },
    "1989-03-21": {
        date: "1989-03-21",
        week: "火",
        week_en: "Tuesday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "1989-04-29": {
        date: "1989-04-29",
        week: "土",
        week_en: "Saturday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "1989-05-03": {
        date: "1989-05-03",
        week: "水",
        week_en: "Wednesday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "1989-05-04": {
        date: "1989-05-04",
        week: "木",
        week_en: "Thursday",
        name: "休日",
        name_en: "Citizen's Holiday"
    },
    "1989-05-05": {
        date: "1989-05-05",
        week: "金",
        week_en: "Friday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "1989-09-15": {
        date: "1989-09-15",
        week: "金",
        week_en: "Friday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "1989-09-23": {
        date: "1989-09-23",
        week: "土",
        week_en: "Saturday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "1989-10-10": {
        date: "1989-10-10",
        week: "火",
        week_en: "Tuesday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "1989-11-03": {
        date: "1989-11-03",
        week: "金",
        week_en: "Friday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "1989-11-23": {
        date: "1989-11-23",
        week: "木",
        week_en: "Thursday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "1989-12-23": {
        date: "1989-12-23",
        week: "土",
        week_en: "Saturday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "1990-01-01": {
        date: "1990-01-01",
        week: "月",
        week_en: "Monday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "1990-01-15": {
        date: "1990-01-15",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "1990-02-11": {
        date: "1990-02-11",
        week: "日",
        week_en: "Sunday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "1990-02-12": {
        date: "1990-02-12",
        week: "月",
        week_en: "Monday",
        name: "建国記念の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1990-03-21": {
        date: "1990-03-21",
        week: "水",
        week_en: "Wednesday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "1990-04-29": {
        date: "1990-04-29",
        week: "日",
        week_en: "Sunday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "1990-04-30": {
        date: "1990-04-30",
        week: "月",
        week_en: "Monday",
        name: "みどりの日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1990-05-03": {
        date: "1990-05-03",
        week: "木",
        week_en: "Thursday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "1990-05-04": {
        date: "1990-05-04",
        week: "金",
        week_en: "Friday",
        name: "休日",
        name_en: "Citizen's Holiday"
    },
    "1990-05-05": {
        date: "1990-05-05",
        week: "土",
        week_en: "Saturday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "1990-09-15": {
        date: "1990-09-15",
        week: "土",
        week_en: "Saturday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "1990-09-23": {
        date: "1990-09-23",
        week: "日",
        week_en: "Sunday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "1990-09-24": {
        date: "1990-09-24",
        week: "月",
        week_en: "Monday",
        name: "秋分の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1990-10-10": {
        date: "1990-10-10",
        week: "水",
        week_en: "Wednesday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "1990-11-03": {
        date: "1990-11-03",
        week: "土",
        week_en: "Saturday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "1990-11-12": {
        date: "1990-11-12",
        week: "月",
        week_en: "Monday",
        name: "即位礼正殿の儀",
        name_en: "The Ceremony of the Enthronement of His Majesty the Emperor (at the Seiden)"
    },
    "1990-11-23": {
        date: "1990-11-23",
        week: "金",
        week_en: "Friday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "1990-12-23": {
        date: "1990-12-23",
        week: "日",
        week_en: "Sunday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "1990-12-24": {
        date: "1990-12-24",
        week: "月",
        week_en: "Monday",
        name: "天皇誕生日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1991-01-01": {
        date: "1991-01-01",
        week: "火",
        week_en: "Tuesday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "1991-01-15": {
        date: "1991-01-15",
        week: "火",
        week_en: "Tuesday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "1991-02-11": {
        date: "1991-02-11",
        week: "月",
        week_en: "Monday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "1991-03-21": {
        date: "1991-03-21",
        week: "木",
        week_en: "Thursday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "1991-04-29": {
        date: "1991-04-29",
        week: "月",
        week_en: "Monday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "1991-05-03": {
        date: "1991-05-03",
        week: "金",
        week_en: "Friday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "1991-05-04": {
        date: "1991-05-04",
        week: "土",
        week_en: "Saturday",
        name: "休日",
        name_en: "Citizen's Holiday"
    },
    "1991-05-05": {
        date: "1991-05-05",
        week: "日",
        week_en: "Sunday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "1991-05-06": {
        date: "1991-05-06",
        week: "月",
        week_en: "Monday",
        name: "こどもの日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1991-09-15": {
        date: "1991-09-15",
        week: "日",
        week_en: "Sunday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "1991-09-16": {
        date: "1991-09-16",
        week: "月",
        week_en: "Monday",
        name: "敬老の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1991-09-23": {
        date: "1991-09-23",
        week: "月",
        week_en: "Monday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "1991-10-10": {
        date: "1991-10-10",
        week: "木",
        week_en: "Thursday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "1991-11-03": {
        date: "1991-11-03",
        week: "日",
        week_en: "Sunday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "1991-11-04": {
        date: "1991-11-04",
        week: "月",
        week_en: "Monday",
        name: "文化の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1991-11-23": {
        date: "1991-11-23",
        week: "土",
        week_en: "Saturday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "1991-12-23": {
        date: "1991-12-23",
        week: "月",
        week_en: "Monday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "1992-01-01": {
        date: "1992-01-01",
        week: "水",
        week_en: "Wednesday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "1992-01-15": {
        date: "1992-01-15",
        week: "水",
        week_en: "Wednesday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "1992-02-11": {
        date: "1992-02-11",
        week: "火",
        week_en: "Tuesday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "1992-03-20": {
        date: "1992-03-20",
        week: "金",
        week_en: "Friday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "1992-04-29": {
        date: "1992-04-29",
        week: "水",
        week_en: "Wednesday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "1992-05-03": {
        date: "1992-05-03",
        week: "日",
        week_en: "Sunday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "1992-05-04": {
        date: "1992-05-04",
        week: "月",
        week_en: "Monday",
        name: "憲法記念日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1992-05-05": {
        date: "1992-05-05",
        week: "火",
        week_en: "Tuesday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "1992-09-15": {
        date: "1992-09-15",
        week: "火",
        week_en: "Tuesday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "1992-09-23": {
        date: "1992-09-23",
        week: "水",
        week_en: "Wednesday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "1992-10-10": {
        date: "1992-10-10",
        week: "土",
        week_en: "Saturday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "1992-11-03": {
        date: "1992-11-03",
        week: "火",
        week_en: "Tuesday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "1992-11-23": {
        date: "1992-11-23",
        week: "月",
        week_en: "Monday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "1992-12-23": {
        date: "1992-12-23",
        week: "水",
        week_en: "Wednesday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "1993-01-01": {
        date: "1993-01-01",
        week: "金",
        week_en: "Friday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "1993-01-15": {
        date: "1993-01-15",
        week: "金",
        week_en: "Friday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "1993-02-11": {
        date: "1993-02-11",
        week: "木",
        week_en: "Thursday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "1993-03-20": {
        date: "1993-03-20",
        week: "土",
        week_en: "Saturday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "1993-04-29": {
        date: "1993-04-29",
        week: "木",
        week_en: "Thursday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "1993-05-03": {
        date: "1993-05-03",
        week: "月",
        week_en: "Monday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "1993-05-04": {
        date: "1993-05-04",
        week: "火",
        week_en: "Tuesday",
        name: "休日",
        name_en: "Citizen's Holiday"
    },
    "1993-05-05": {
        date: "1993-05-05",
        week: "水",
        week_en: "Wednesday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "1993-06-09": {
        date: "1993-06-09",
        week: "水",
        week_en: "Wednesday",
        name: "結婚の儀",
        name_en: "The Rite of Wedding of HIH Crown Prince Naruhito"
    },
    "1993-09-15": {
        date: "1993-09-15",
        week: "水",
        week_en: "Wednesday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "1993-09-23": {
        date: "1993-09-23",
        week: "木",
        week_en: "Thursday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "1993-10-10": {
        date: "1993-10-10",
        week: "日",
        week_en: "Sunday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "1993-10-11": {
        date: "1993-10-11",
        week: "月",
        week_en: "Monday",
        name: "体育の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1993-11-03": {
        date: "1993-11-03",
        week: "水",
        week_en: "Wednesday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "1993-11-23": {
        date: "1993-11-23",
        week: "火",
        week_en: "Tuesday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "1993-12-23": {
        date: "1993-12-23",
        week: "木",
        week_en: "Thursday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "1994-01-01": {
        date: "1994-01-01",
        week: "土",
        week_en: "Saturday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "1994-01-15": {
        date: "1994-01-15",
        week: "土",
        week_en: "Saturday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "1994-02-11": {
        date: "1994-02-11",
        week: "金",
        week_en: "Friday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "1994-03-21": {
        date: "1994-03-21",
        week: "月",
        week_en: "Monday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "1994-04-29": {
        date: "1994-04-29",
        week: "金",
        week_en: "Friday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "1994-05-03": {
        date: "1994-05-03",
        week: "火",
        week_en: "Tuesday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "1994-05-04": {
        date: "1994-05-04",
        week: "水",
        week_en: "Wednesday",
        name: "休日",
        name_en: "Citizen's Holiday"
    },
    "1994-05-05": {
        date: "1994-05-05",
        week: "木",
        week_en: "Thursday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "1994-09-15": {
        date: "1994-09-15",
        week: "木",
        week_en: "Thursday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "1994-09-23": {
        date: "1994-09-23",
        week: "金",
        week_en: "Friday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "1994-10-10": {
        date: "1994-10-10",
        week: "月",
        week_en: "Monday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "1994-11-03": {
        date: "1994-11-03",
        week: "木",
        week_en: "Thursday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "1994-11-23": {
        date: "1994-11-23",
        week: "水",
        week_en: "Wednesday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "1994-12-23": {
        date: "1994-12-23",
        week: "金",
        week_en: "Friday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "1995-01-01": {
        date: "1995-01-01",
        week: "日",
        week_en: "Sunday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "1995-01-02": {
        date: "1995-01-02",
        week: "月",
        week_en: "Monday",
        name: "元日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1995-01-15": {
        date: "1995-01-15",
        week: "日",
        week_en: "Sunday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "1995-01-16": {
        date: "1995-01-16",
        week: "月",
        week_en: "Monday",
        name: "成人の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1995-02-11": {
        date: "1995-02-11",
        week: "土",
        week_en: "Saturday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "1995-03-21": {
        date: "1995-03-21",
        week: "火",
        week_en: "Tuesday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "1995-04-29": {
        date: "1995-04-29",
        week: "土",
        week_en: "Saturday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "1995-05-03": {
        date: "1995-05-03",
        week: "水",
        week_en: "Wednesday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "1995-05-04": {
        date: "1995-05-04",
        week: "木",
        week_en: "Thursday",
        name: "休日",
        name_en: "Citizen's Holiday"
    },
    "1995-05-05": {
        date: "1995-05-05",
        week: "金",
        week_en: "Friday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "1995-09-15": {
        date: "1995-09-15",
        week: "金",
        week_en: "Friday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "1995-09-23": {
        date: "1995-09-23",
        week: "土",
        week_en: "Saturday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "1995-10-10": {
        date: "1995-10-10",
        week: "火",
        week_en: "Tuesday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "1995-11-03": {
        date: "1995-11-03",
        week: "金",
        week_en: "Friday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "1995-11-23": {
        date: "1995-11-23",
        week: "木",
        week_en: "Thursday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "1995-12-23": {
        date: "1995-12-23",
        week: "土",
        week_en: "Saturday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "1996-01-01": {
        date: "1996-01-01",
        week: "月",
        week_en: "Monday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "1996-01-15": {
        date: "1996-01-15",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "1996-02-11": {
        date: "1996-02-11",
        week: "日",
        week_en: "Sunday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "1996-02-12": {
        date: "1996-02-12",
        week: "月",
        week_en: "Monday",
        name: "建国記念の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1996-03-20": {
        date: "1996-03-20",
        week: "水",
        week_en: "Wednesday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "1996-04-29": {
        date: "1996-04-29",
        week: "月",
        week_en: "Monday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "1996-05-03": {
        date: "1996-05-03",
        week: "金",
        week_en: "Friday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "1996-05-04": {
        date: "1996-05-04",
        week: "土",
        week_en: "Saturday",
        name: "休日",
        name_en: "Citizen's Holiday"
    },
    "1996-05-05": {
        date: "1996-05-05",
        week: "日",
        week_en: "Sunday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "1996-05-06": {
        date: "1996-05-06",
        week: "月",
        week_en: "Monday",
        name: "こどもの日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1996-07-20": {
        date: "1996-07-20",
        week: "土",
        week_en: "Saturday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "1996-09-15": {
        date: "1996-09-15",
        week: "日",
        week_en: "Sunday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "1996-09-16": {
        date: "1996-09-16",
        week: "月",
        week_en: "Monday",
        name: "敬老の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1996-09-23": {
        date: "1996-09-23",
        week: "月",
        week_en: "Monday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "1996-10-10": {
        date: "1996-10-10",
        week: "木",
        week_en: "Thursday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "1996-11-03": {
        date: "1996-11-03",
        week: "日",
        week_en: "Sunday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "1996-11-04": {
        date: "1996-11-04",
        week: "月",
        week_en: "Monday",
        name: "文化の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1996-11-23": {
        date: "1996-11-23",
        week: "土",
        week_en: "Saturday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "1996-12-23": {
        date: "1996-12-23",
        week: "月",
        week_en: "Monday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "1997-01-01": {
        date: "1997-01-01",
        week: "水",
        week_en: "Wednesday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "1997-01-15": {
        date: "1997-01-15",
        week: "水",
        week_en: "Wednesday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "1997-02-11": {
        date: "1997-02-11",
        week: "火",
        week_en: "Tuesday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "1997-03-20": {
        date: "1997-03-20",
        week: "木",
        week_en: "Thursday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "1997-04-29": {
        date: "1997-04-29",
        week: "火",
        week_en: "Tuesday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "1997-05-03": {
        date: "1997-05-03",
        week: "土",
        week_en: "Saturday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "1997-05-05": {
        date: "1997-05-05",
        week: "月",
        week_en: "Monday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "1997-07-20": {
        date: "1997-07-20",
        week: "日",
        week_en: "Sunday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "1997-07-21": {
        date: "1997-07-21",
        week: "月",
        week_en: "Monday",
        name: "海の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1997-09-15": {
        date: "1997-09-15",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "1997-09-23": {
        date: "1997-09-23",
        week: "火",
        week_en: "Tuesday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "1997-10-10": {
        date: "1997-10-10",
        week: "金",
        week_en: "Friday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "1997-11-03": {
        date: "1997-11-03",
        week: "月",
        week_en: "Monday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "1997-11-23": {
        date: "1997-11-23",
        week: "日",
        week_en: "Sunday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "1997-11-24": {
        date: "1997-11-24",
        week: "月",
        week_en: "Monday",
        name: "勤労感謝の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1997-12-23": {
        date: "1997-12-23",
        week: "火",
        week_en: "Tuesday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "1998-01-01": {
        date: "1998-01-01",
        week: "木",
        week_en: "Thursday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "1998-01-15": {
        date: "1998-01-15",
        week: "木",
        week_en: "Thursday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "1998-02-11": {
        date: "1998-02-11",
        week: "水",
        week_en: "Wednesday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "1998-03-21": {
        date: "1998-03-21",
        week: "土",
        week_en: "Saturday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "1998-04-29": {
        date: "1998-04-29",
        week: "水",
        week_en: "Wednesday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "1998-05-03": {
        date: "1998-05-03",
        week: "日",
        week_en: "Sunday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "1998-05-04": {
        date: "1998-05-04",
        week: "月",
        week_en: "Monday",
        name: "憲法記念日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1998-05-05": {
        date: "1998-05-05",
        week: "火",
        week_en: "Tuesday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "1998-07-20": {
        date: "1998-07-20",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "1998-09-15": {
        date: "1998-09-15",
        week: "火",
        week_en: "Tuesday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "1998-09-23": {
        date: "1998-09-23",
        week: "水",
        week_en: "Wednesday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "1998-10-10": {
        date: "1998-10-10",
        week: "土",
        week_en: "Saturday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "1998-11-03": {
        date: "1998-11-03",
        week: "火",
        week_en: "Tuesday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "1998-11-23": {
        date: "1998-11-23",
        week: "月",
        week_en: "Monday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "1998-12-23": {
        date: "1998-12-23",
        week: "水",
        week_en: "Wednesday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "1999-01-01": {
        date: "1999-01-01",
        week: "金",
        week_en: "Friday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "1999-01-15": {
        date: "1999-01-15",
        week: "金",
        week_en: "Friday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "1999-02-11": {
        date: "1999-02-11",
        week: "木",
        week_en: "Thursday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "1999-03-21": {
        date: "1999-03-21",
        week: "日",
        week_en: "Sunday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "1999-03-22": {
        date: "1999-03-22",
        week: "月",
        week_en: "Monday",
        name: "春分の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1999-04-29": {
        date: "1999-04-29",
        week: "木",
        week_en: "Thursday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "1999-05-03": {
        date: "1999-05-03",
        week: "月",
        week_en: "Monday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "1999-05-04": {
        date: "1999-05-04",
        week: "火",
        week_en: "Tuesday",
        name: "休日",
        name_en: "Citizen's Holiday"
    },
    "1999-05-05": {
        date: "1999-05-05",
        week: "水",
        week_en: "Wednesday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "1999-07-20": {
        date: "1999-07-20",
        week: "火",
        week_en: "Tuesday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "1999-09-15": {
        date: "1999-09-15",
        week: "水",
        week_en: "Wednesday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "1999-09-23": {
        date: "1999-09-23",
        week: "木",
        week_en: "Thursday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "1999-10-10": {
        date: "1999-10-10",
        week: "日",
        week_en: "Sunday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "1999-10-11": {
        date: "1999-10-11",
        week: "月",
        week_en: "Monday",
        name: "体育の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "1999-11-03": {
        date: "1999-11-03",
        week: "水",
        week_en: "Wednesday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "1999-11-23": {
        date: "1999-11-23",
        week: "火",
        week_en: "Tuesday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "1999-12-23": {
        date: "1999-12-23",
        week: "木",
        week_en: "Thursday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2000-01-01": {
        date: "2000-01-01",
        week: "土",
        week_en: "Saturday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2000-01-10": {
        date: "2000-01-10",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2000-02-11": {
        date: "2000-02-11",
        week: "金",
        week_en: "Friday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2000-03-20": {
        date: "2000-03-20",
        week: "月",
        week_en: "Monday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2000-04-29": {
        date: "2000-04-29",
        week: "土",
        week_en: "Saturday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2000-05-03": {
        date: "2000-05-03",
        week: "水",
        week_en: "Wednesday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2000-05-04": {
        date: "2000-05-04",
        week: "木",
        week_en: "Thursday",
        name: "休日",
        name_en: "Citizen's Holiday"
    },
    "2000-05-05": {
        date: "2000-05-05",
        week: "金",
        week_en: "Friday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2000-07-20": {
        date: "2000-07-20",
        week: "木",
        week_en: "Thursday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2000-09-15": {
        date: "2000-09-15",
        week: "金",
        week_en: "Friday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2000-09-23": {
        date: "2000-09-23",
        week: "土",
        week_en: "Saturday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2000-10-09": {
        date: "2000-10-09",
        week: "月",
        week_en: "Monday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "2000-11-03": {
        date: "2000-11-03",
        week: "金",
        week_en: "Friday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2000-11-23": {
        date: "2000-11-23",
        week: "木",
        week_en: "Thursday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2000-12-23": {
        date: "2000-12-23",
        week: "土",
        week_en: "Saturday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2001-01-01": {
        date: "2001-01-01",
        week: "月",
        week_en: "Monday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2001-01-08": {
        date: "2001-01-08",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2001-02-11": {
        date: "2001-02-11",
        week: "日",
        week_en: "Sunday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2001-02-12": {
        date: "2001-02-12",
        week: "月",
        week_en: "Monday",
        name: "建国記念の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2001-03-20": {
        date: "2001-03-20",
        week: "火",
        week_en: "Tuesday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2001-04-29": {
        date: "2001-04-29",
        week: "日",
        week_en: "Sunday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2001-04-30": {
        date: "2001-04-30",
        week: "月",
        week_en: "Monday",
        name: "みどりの日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2001-05-03": {
        date: "2001-05-03",
        week: "木",
        week_en: "Thursday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2001-05-04": {
        date: "2001-05-04",
        week: "金",
        week_en: "Friday",
        name: "休日",
        name_en: "Citizen's Holiday"
    },
    "2001-05-05": {
        date: "2001-05-05",
        week: "土",
        week_en: "Saturday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2001-07-20": {
        date: "2001-07-20",
        week: "金",
        week_en: "Friday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2001-09-15": {
        date: "2001-09-15",
        week: "土",
        week_en: "Saturday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2001-09-23": {
        date: "2001-09-23",
        week: "日",
        week_en: "Sunday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2001-09-24": {
        date: "2001-09-24",
        week: "月",
        week_en: "Monday",
        name: "秋分の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2001-10-08": {
        date: "2001-10-08",
        week: "月",
        week_en: "Monday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "2001-11-03": {
        date: "2001-11-03",
        week: "土",
        week_en: "Saturday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2001-11-23": {
        date: "2001-11-23",
        week: "金",
        week_en: "Friday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2001-12-23": {
        date: "2001-12-23",
        week: "日",
        week_en: "Sunday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2001-12-24": {
        date: "2001-12-24",
        week: "月",
        week_en: "Monday",
        name: "天皇誕生日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2002-01-01": {
        date: "2002-01-01",
        week: "火",
        week_en: "Tuesday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2002-01-14": {
        date: "2002-01-14",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2002-02-11": {
        date: "2002-02-11",
        week: "月",
        week_en: "Monday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2002-03-21": {
        date: "2002-03-21",
        week: "木",
        week_en: "Thursday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2002-04-29": {
        date: "2002-04-29",
        week: "月",
        week_en: "Monday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2002-05-03": {
        date: "2002-05-03",
        week: "金",
        week_en: "Friday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2002-05-04": {
        date: "2002-05-04",
        week: "土",
        week_en: "Saturday",
        name: "休日",
        name_en: "Citizen's Holiday"
    },
    "2002-05-05": {
        date: "2002-05-05",
        week: "日",
        week_en: "Sunday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2002-05-06": {
        date: "2002-05-06",
        week: "月",
        week_en: "Monday",
        name: "こどもの日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2002-07-20": {
        date: "2002-07-20",
        week: "土",
        week_en: "Saturday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2002-09-15": {
        date: "2002-09-15",
        week: "日",
        week_en: "Sunday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2002-09-16": {
        date: "2002-09-16",
        week: "月",
        week_en: "Monday",
        name: "敬老の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2002-09-23": {
        date: "2002-09-23",
        week: "月",
        week_en: "Monday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2002-10-14": {
        date: "2002-10-14",
        week: "月",
        week_en: "Monday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "2002-11-03": {
        date: "2002-11-03",
        week: "日",
        week_en: "Sunday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2002-11-04": {
        date: "2002-11-04",
        week: "月",
        week_en: "Monday",
        name: "文化の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2002-11-23": {
        date: "2002-11-23",
        week: "土",
        week_en: "Saturday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2002-12-23": {
        date: "2002-12-23",
        week: "月",
        week_en: "Monday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2003-01-01": {
        date: "2003-01-01",
        week: "水",
        week_en: "Wednesday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2003-01-13": {
        date: "2003-01-13",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2003-02-11": {
        date: "2003-02-11",
        week: "火",
        week_en: "Tuesday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2003-03-21": {
        date: "2003-03-21",
        week: "金",
        week_en: "Friday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2003-04-29": {
        date: "2003-04-29",
        week: "火",
        week_en: "Tuesday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2003-05-03": {
        date: "2003-05-03",
        week: "土",
        week_en: "Saturday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2003-05-05": {
        date: "2003-05-05",
        week: "月",
        week_en: "Monday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2003-07-21": {
        date: "2003-07-21",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2003-09-15": {
        date: "2003-09-15",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2003-09-23": {
        date: "2003-09-23",
        week: "火",
        week_en: "Tuesday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2003-10-13": {
        date: "2003-10-13",
        week: "月",
        week_en: "Monday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "2003-11-03": {
        date: "2003-11-03",
        week: "月",
        week_en: "Monday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2003-11-23": {
        date: "2003-11-23",
        week: "日",
        week_en: "Sunday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2003-11-24": {
        date: "2003-11-24",
        week: "月",
        week_en: "Monday",
        name: "勤労感謝の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2003-12-23": {
        date: "2003-12-23",
        week: "火",
        week_en: "Tuesday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2004-01-01": {
        date: "2004-01-01",
        week: "木",
        week_en: "Thursday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2004-01-12": {
        date: "2004-01-12",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2004-02-11": {
        date: "2004-02-11",
        week: "水",
        week_en: "Wednesday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2004-03-20": {
        date: "2004-03-20",
        week: "土",
        week_en: "Saturday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2004-04-29": {
        date: "2004-04-29",
        week: "木",
        week_en: "Thursday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2004-05-03": {
        date: "2004-05-03",
        week: "月",
        week_en: "Monday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2004-05-04": {
        date: "2004-05-04",
        week: "火",
        week_en: "Tuesday",
        name: "休日",
        name_en: "Citizen's Holiday"
    },
    "2004-05-05": {
        date: "2004-05-05",
        week: "水",
        week_en: "Wednesday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2004-07-19": {
        date: "2004-07-19",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2004-09-20": {
        date: "2004-09-20",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2004-09-23": {
        date: "2004-09-23",
        week: "木",
        week_en: "Thursday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2004-10-11": {
        date: "2004-10-11",
        week: "月",
        week_en: "Monday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "2004-11-03": {
        date: "2004-11-03",
        week: "水",
        week_en: "Wednesday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2004-11-23": {
        date: "2004-11-23",
        week: "火",
        week_en: "Tuesday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2004-12-23": {
        date: "2004-12-23",
        week: "木",
        week_en: "Thursday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2005-01-01": {
        date: "2005-01-01",
        week: "土",
        week_en: "Saturday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2005-01-10": {
        date: "2005-01-10",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2005-02-11": {
        date: "2005-02-11",
        week: "金",
        week_en: "Friday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2005-03-20": {
        date: "2005-03-20",
        week: "日",
        week_en: "Sunday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2005-03-21": {
        date: "2005-03-21",
        week: "月",
        week_en: "Monday",
        name: "春分の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2005-04-29": {
        date: "2005-04-29",
        week: "金",
        week_en: "Friday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2005-05-03": {
        date: "2005-05-03",
        week: "火",
        week_en: "Tuesday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2005-05-04": {
        date: "2005-05-04",
        week: "水",
        week_en: "Wednesday",
        name: "休日",
        name_en: "Citizen's Holiday"
    },
    "2005-05-05": {
        date: "2005-05-05",
        week: "木",
        week_en: "Thursday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2005-07-18": {
        date: "2005-07-18",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2005-09-19": {
        date: "2005-09-19",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2005-09-23": {
        date: "2005-09-23",
        week: "金",
        week_en: "Friday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2005-10-10": {
        date: "2005-10-10",
        week: "月",
        week_en: "Monday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "2005-11-03": {
        date: "2005-11-03",
        week: "木",
        week_en: "Thursday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2005-11-23": {
        date: "2005-11-23",
        week: "水",
        week_en: "Wednesday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2005-12-23": {
        date: "2005-12-23",
        week: "金",
        week_en: "Friday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2006-01-01": {
        date: "2006-01-01",
        week: "日",
        week_en: "Sunday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2006-01-02": {
        date: "2006-01-02",
        week: "月",
        week_en: "Monday",
        name: "元日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2006-01-09": {
        date: "2006-01-09",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2006-02-11": {
        date: "2006-02-11",
        week: "土",
        week_en: "Saturday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2006-03-21": {
        date: "2006-03-21",
        week: "火",
        week_en: "Tuesday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2006-04-29": {
        date: "2006-04-29",
        week: "土",
        week_en: "Saturday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2006-05-03": {
        date: "2006-05-03",
        week: "水",
        week_en: "Wednesday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2006-05-04": {
        date: "2006-05-04",
        week: "木",
        week_en: "Thursday",
        name: "休日",
        name_en: "Citizen's Holiday"
    },
    "2006-05-05": {
        date: "2006-05-05",
        week: "金",
        week_en: "Friday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2006-07-17": {
        date: "2006-07-17",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2006-09-18": {
        date: "2006-09-18",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2006-09-23": {
        date: "2006-09-23",
        week: "土",
        week_en: "Saturday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2006-10-09": {
        date: "2006-10-09",
        week: "月",
        week_en: "Monday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "2006-11-03": {
        date: "2006-11-03",
        week: "金",
        week_en: "Friday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2006-11-23": {
        date: "2006-11-23",
        week: "木",
        week_en: "Thursday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2006-12-23": {
        date: "2006-12-23",
        week: "土",
        week_en: "Saturday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2007-01-01": {
        date: "2007-01-01",
        week: "月",
        week_en: "Monday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2007-01-08": {
        date: "2007-01-08",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2007-02-11": {
        date: "2007-02-11",
        week: "日",
        week_en: "Sunday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2007-02-12": {
        date: "2007-02-12",
        week: "月",
        week_en: "Monday",
        name: "建国記念の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2007-03-21": {
        date: "2007-03-21",
        week: "水",
        week_en: "Wednesday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2007-04-29": {
        date: "2007-04-29",
        week: "日",
        week_en: "Sunday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2007-04-30": {
        date: "2007-04-30",
        week: "月",
        week_en: "Monday",
        name: "昭和の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2007-05-03": {
        date: "2007-05-03",
        week: "木",
        week_en: "Thursday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2007-05-04": {
        date: "2007-05-04",
        week: "金",
        week_en: "Friday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2007-05-05": {
        date: "2007-05-05",
        week: "土",
        week_en: "Saturday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2007-07-16": {
        date: "2007-07-16",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2007-09-17": {
        date: "2007-09-17",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2007-09-23": {
        date: "2007-09-23",
        week: "日",
        week_en: "Sunday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2007-09-24": {
        date: "2007-09-24",
        week: "月",
        week_en: "Monday",
        name: "秋分の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2007-10-08": {
        date: "2007-10-08",
        week: "月",
        week_en: "Monday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "2007-11-03": {
        date: "2007-11-03",
        week: "土",
        week_en: "Saturday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2007-11-23": {
        date: "2007-11-23",
        week: "金",
        week_en: "Friday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2007-12-23": {
        date: "2007-12-23",
        week: "日",
        week_en: "Sunday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2007-12-24": {
        date: "2007-12-24",
        week: "月",
        week_en: "Monday",
        name: "天皇誕生日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2008-01-01": {
        date: "2008-01-01",
        week: "火",
        week_en: "Tuesday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2008-01-14": {
        date: "2008-01-14",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2008-02-11": {
        date: "2008-02-11",
        week: "月",
        week_en: "Monday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2008-03-20": {
        date: "2008-03-20",
        week: "木",
        week_en: "Thursday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2008-04-29": {
        date: "2008-04-29",
        week: "火",
        week_en: "Tuesday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2008-05-03": {
        date: "2008-05-03",
        week: "土",
        week_en: "Saturday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2008-05-04": {
        date: "2008-05-04",
        week: "日",
        week_en: "Sunday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2008-05-05": {
        date: "2008-05-05",
        week: "月",
        week_en: "Monday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2008-05-06": {
        date: "2008-05-06",
        week: "火",
        week_en: "Tuesday",
        name: "こどもの日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2008-07-21": {
        date: "2008-07-21",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2008-09-15": {
        date: "2008-09-15",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2008-09-23": {
        date: "2008-09-23",
        week: "火",
        week_en: "Tuesday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2008-10-13": {
        date: "2008-10-13",
        week: "月",
        week_en: "Monday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "2008-11-03": {
        date: "2008-11-03",
        week: "月",
        week_en: "Monday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2008-11-23": {
        date: "2008-11-23",
        week: "日",
        week_en: "Sunday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2008-11-24": {
        date: "2008-11-24",
        week: "月",
        week_en: "Monday",
        name: "勤労感謝の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2008-12-23": {
        date: "2008-12-23",
        week: "火",
        week_en: "Tuesday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2009-01-01": {
        date: "2009-01-01",
        week: "木",
        week_en: "Thursday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2009-01-12": {
        date: "2009-01-12",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2009-02-11": {
        date: "2009-02-11",
        week: "水",
        week_en: "Wednesday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2009-03-20": {
        date: "2009-03-20",
        week: "金",
        week_en: "Friday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2009-04-29": {
        date: "2009-04-29",
        week: "水",
        week_en: "Wednesday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2009-05-03": {
        date: "2009-05-03",
        week: "日",
        week_en: "Sunday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2009-05-04": {
        date: "2009-05-04",
        week: "月",
        week_en: "Monday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2009-05-05": {
        date: "2009-05-05",
        week: "火",
        week_en: "Tuesday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2009-05-06": {
        date: "2009-05-06",
        week: "水",
        week_en: "Wednesday",
        name: "こどもの日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2009-07-20": {
        date: "2009-07-20",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2009-09-21": {
        date: "2009-09-21",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2009-09-22": {
        date: "2009-09-22",
        week: "火",
        week_en: "Tuesday",
        name: "休日",
        name_en: "Citizen's Holiday"
    },
    "2009-09-23": {
        date: "2009-09-23",
        week: "水",
        week_en: "Wednesday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2009-10-12": {
        date: "2009-10-12",
        week: "月",
        week_en: "Monday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "2009-11-03": {
        date: "2009-11-03",
        week: "火",
        week_en: "Tuesday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2009-11-23": {
        date: "2009-11-23",
        week: "月",
        week_en: "Monday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2009-12-23": {
        date: "2009-12-23",
        week: "水",
        week_en: "Wednesday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2010-01-01": {
        date: "2010-01-01",
        week: "金",
        week_en: "Friday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2010-01-11": {
        date: "2010-01-11",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2010-02-11": {
        date: "2010-02-11",
        week: "木",
        week_en: "Thursday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2010-03-21": {
        date: "2010-03-21",
        week: "日",
        week_en: "Sunday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2010-03-22": {
        date: "2010-03-22",
        week: "月",
        week_en: "Monday",
        name: "春分の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2010-04-29": {
        date: "2010-04-29",
        week: "木",
        week_en: "Thursday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2010-05-03": {
        date: "2010-05-03",
        week: "月",
        week_en: "Monday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2010-05-04": {
        date: "2010-05-04",
        week: "火",
        week_en: "Tuesday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2010-05-05": {
        date: "2010-05-05",
        week: "水",
        week_en: "Wednesday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2010-07-19": {
        date: "2010-07-19",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2010-09-20": {
        date: "2010-09-20",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2010-09-23": {
        date: "2010-09-23",
        week: "木",
        week_en: "Thursday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2010-10-11": {
        date: "2010-10-11",
        week: "月",
        week_en: "Monday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "2010-11-03": {
        date: "2010-11-03",
        week: "水",
        week_en: "Wednesday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2010-11-23": {
        date: "2010-11-23",
        week: "火",
        week_en: "Tuesday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2010-12-23": {
        date: "2010-12-23",
        week: "木",
        week_en: "Thursday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2011-01-01": {
        date: "2011-01-01",
        week: "土",
        week_en: "Saturday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2011-01-10": {
        date: "2011-01-10",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2011-02-11": {
        date: "2011-02-11",
        week: "金",
        week_en: "Friday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2011-03-21": {
        date: "2011-03-21",
        week: "月",
        week_en: "Monday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2011-04-29": {
        date: "2011-04-29",
        week: "金",
        week_en: "Friday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2011-05-03": {
        date: "2011-05-03",
        week: "火",
        week_en: "Tuesday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2011-05-04": {
        date: "2011-05-04",
        week: "水",
        week_en: "Wednesday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2011-05-05": {
        date: "2011-05-05",
        week: "木",
        week_en: "Thursday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2011-07-18": {
        date: "2011-07-18",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2011-09-19": {
        date: "2011-09-19",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2011-09-23": {
        date: "2011-09-23",
        week: "金",
        week_en: "Friday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2011-10-10": {
        date: "2011-10-10",
        week: "月",
        week_en: "Monday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "2011-11-03": {
        date: "2011-11-03",
        week: "木",
        week_en: "Thursday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2011-11-23": {
        date: "2011-11-23",
        week: "水",
        week_en: "Wednesday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2011-12-23": {
        date: "2011-12-23",
        week: "金",
        week_en: "Friday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2012-01-01": {
        date: "2012-01-01",
        week: "日",
        week_en: "Sunday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2012-01-02": {
        date: "2012-01-02",
        week: "月",
        week_en: "Monday",
        name: "元日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2012-01-09": {
        date: "2012-01-09",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2012-02-11": {
        date: "2012-02-11",
        week: "土",
        week_en: "Saturday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2012-03-20": {
        date: "2012-03-20",
        week: "火",
        week_en: "Tuesday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2012-04-29": {
        date: "2012-04-29",
        week: "日",
        week_en: "Sunday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2012-04-30": {
        date: "2012-04-30",
        week: "月",
        week_en: "Monday",
        name: "昭和の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2012-05-03": {
        date: "2012-05-03",
        week: "木",
        week_en: "Thursday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2012-05-04": {
        date: "2012-05-04",
        week: "金",
        week_en: "Friday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2012-05-05": {
        date: "2012-05-05",
        week: "土",
        week_en: "Saturday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2012-07-16": {
        date: "2012-07-16",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2012-09-17": {
        date: "2012-09-17",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2012-09-22": {
        date: "2012-09-22",
        week: "土",
        week_en: "Saturday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2012-10-08": {
        date: "2012-10-08",
        week: "月",
        week_en: "Monday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "2012-11-03": {
        date: "2012-11-03",
        week: "土",
        week_en: "Saturday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2012-11-23": {
        date: "2012-11-23",
        week: "金",
        week_en: "Friday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2012-12-23": {
        date: "2012-12-23",
        week: "日",
        week_en: "Sunday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2012-12-24": {
        date: "2012-12-24",
        week: "月",
        week_en: "Monday",
        name: "天皇誕生日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2013-01-01": {
        date: "2013-01-01",
        week: "火",
        week_en: "Tuesday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2013-01-14": {
        date: "2013-01-14",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2013-02-11": {
        date: "2013-02-11",
        week: "月",
        week_en: "Monday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2013-03-20": {
        date: "2013-03-20",
        week: "水",
        week_en: "Wednesday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2013-04-29": {
        date: "2013-04-29",
        week: "月",
        week_en: "Monday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2013-05-03": {
        date: "2013-05-03",
        week: "金",
        week_en: "Friday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2013-05-04": {
        date: "2013-05-04",
        week: "土",
        week_en: "Saturday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2013-05-05": {
        date: "2013-05-05",
        week: "日",
        week_en: "Sunday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2013-05-06": {
        date: "2013-05-06",
        week: "月",
        week_en: "Monday",
        name: "こどもの日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2013-07-15": {
        date: "2013-07-15",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2013-09-16": {
        date: "2013-09-16",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2013-09-23": {
        date: "2013-09-23",
        week: "月",
        week_en: "Monday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2013-10-14": {
        date: "2013-10-14",
        week: "月",
        week_en: "Monday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "2013-11-03": {
        date: "2013-11-03",
        week: "日",
        week_en: "Sunday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2013-11-04": {
        date: "2013-11-04",
        week: "月",
        week_en: "Monday",
        name: "文化の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2013-11-23": {
        date: "2013-11-23",
        week: "土",
        week_en: "Saturday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2013-12-23": {
        date: "2013-12-23",
        week: "月",
        week_en: "Monday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2014-01-01": {
        date: "2014-01-01",
        week: "水",
        week_en: "Wednesday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2014-01-13": {
        date: "2014-01-13",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2014-02-11": {
        date: "2014-02-11",
        week: "火",
        week_en: "Tuesday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2014-03-21": {
        date: "2014-03-21",
        week: "金",
        week_en: "Friday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2014-04-29": {
        date: "2014-04-29",
        week: "火",
        week_en: "Tuesday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2014-05-03": {
        date: "2014-05-03",
        week: "土",
        week_en: "Saturday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2014-05-04": {
        date: "2014-05-04",
        week: "日",
        week_en: "Sunday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2014-05-05": {
        date: "2014-05-05",
        week: "月",
        week_en: "Monday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2014-05-06": {
        date: "2014-05-06",
        week: "火",
        week_en: "Tuesday",
        name: "こどもの日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2014-07-21": {
        date: "2014-07-21",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2014-09-15": {
        date: "2014-09-15",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2014-09-23": {
        date: "2014-09-23",
        week: "火",
        week_en: "Tuesday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2014-10-13": {
        date: "2014-10-13",
        week: "月",
        week_en: "Monday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "2014-11-03": {
        date: "2014-11-03",
        week: "月",
        week_en: "Monday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2014-11-23": {
        date: "2014-11-23",
        week: "日",
        week_en: "Sunday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2014-11-24": {
        date: "2014-11-24",
        week: "月",
        week_en: "Monday",
        name: "勤労感謝の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2014-12-23": {
        date: "2014-12-23",
        week: "火",
        week_en: "Tuesday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2015-01-01": {
        date: "2015-01-01",
        week: "木",
        week_en: "Thursday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2015-01-12": {
        date: "2015-01-12",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2015-02-11": {
        date: "2015-02-11",
        week: "水",
        week_en: "Wednesday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2015-03-21": {
        date: "2015-03-21",
        week: "土",
        week_en: "Saturday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2015-04-29": {
        date: "2015-04-29",
        week: "水",
        week_en: "Wednesday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2015-05-03": {
        date: "2015-05-03",
        week: "日",
        week_en: "Sunday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2015-05-04": {
        date: "2015-05-04",
        week: "月",
        week_en: "Monday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2015-05-05": {
        date: "2015-05-05",
        week: "火",
        week_en: "Tuesday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2015-05-06": {
        date: "2015-05-06",
        week: "水",
        week_en: "Wednesday",
        name: "こどもの日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2015-07-20": {
        date: "2015-07-20",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2015-09-21": {
        date: "2015-09-21",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2015-09-22": {
        date: "2015-09-22",
        week: "火",
        week_en: "Tuesday",
        name: "休日",
        name_en: "Citizen's Holiday"
    },
    "2015-09-23": {
        date: "2015-09-23",
        week: "水",
        week_en: "Wednesday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2015-10-12": {
        date: "2015-10-12",
        week: "月",
        week_en: "Monday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "2015-11-03": {
        date: "2015-11-03",
        week: "火",
        week_en: "Tuesday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2015-11-23": {
        date: "2015-11-23",
        week: "月",
        week_en: "Monday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2015-12-23": {
        date: "2015-12-23",
        week: "水",
        week_en: "Wednesday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2016-01-01": {
        date: "2016-01-01",
        week: "金",
        week_en: "Friday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2016-01-11": {
        date: "2016-01-11",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2016-02-11": {
        date: "2016-02-11",
        week: "木",
        week_en: "Thursday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2016-03-20": {
        date: "2016-03-20",
        week: "日",
        week_en: "Sunday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2016-03-21": {
        date: "2016-03-21",
        week: "月",
        week_en: "Monday",
        name: "春分の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2016-04-29": {
        date: "2016-04-29",
        week: "金",
        week_en: "Friday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2016-05-03": {
        date: "2016-05-03",
        week: "火",
        week_en: "Tuesday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2016-05-04": {
        date: "2016-05-04",
        week: "水",
        week_en: "Wednesday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2016-05-05": {
        date: "2016-05-05",
        week: "木",
        week_en: "Thursday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2016-07-18": {
        date: "2016-07-18",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2016-08-11": {
        date: "2016-08-11",
        week: "木",
        week_en: "Thursday",
        name: "山の日",
        name_en: "Mountain Day"
    },
    "2016-09-19": {
        date: "2016-09-19",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2016-09-22": {
        date: "2016-09-22",
        week: "木",
        week_en: "Thursday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2016-10-10": {
        date: "2016-10-10",
        week: "月",
        week_en: "Monday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "2016-11-03": {
        date: "2016-11-03",
        week: "木",
        week_en: "Thursday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2016-11-23": {
        date: "2016-11-23",
        week: "水",
        week_en: "Wednesday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2016-12-23": {
        date: "2016-12-23",
        week: "金",
        week_en: "Friday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2017-01-01": {
        date: "2017-01-01",
        week: "日",
        week_en: "Sunday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2017-01-02": {
        date: "2017-01-02",
        week: "月",
        week_en: "Monday",
        name: "元日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2017-01-09": {
        date: "2017-01-09",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2017-02-11": {
        date: "2017-02-11",
        week: "土",
        week_en: "Saturday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2017-03-20": {
        date: "2017-03-20",
        week: "月",
        week_en: "Monday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2017-04-29": {
        date: "2017-04-29",
        week: "土",
        week_en: "Saturday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2017-05-03": {
        date: "2017-05-03",
        week: "水",
        week_en: "Wednesday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2017-05-04": {
        date: "2017-05-04",
        week: "木",
        week_en: "Thursday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2017-05-05": {
        date: "2017-05-05",
        week: "金",
        week_en: "Friday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2017-07-17": {
        date: "2017-07-17",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2017-08-11": {
        date: "2017-08-11",
        week: "金",
        week_en: "Friday",
        name: "山の日",
        name_en: "Mountain Day"
    },
    "2017-09-18": {
        date: "2017-09-18",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2017-09-23": {
        date: "2017-09-23",
        week: "土",
        week_en: "Saturday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2017-10-09": {
        date: "2017-10-09",
        week: "月",
        week_en: "Monday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "2017-11-03": {
        date: "2017-11-03",
        week: "金",
        week_en: "Friday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2017-11-23": {
        date: "2017-11-23",
        week: "木",
        week_en: "Thursday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2017-12-23": {
        date: "2017-12-23",
        week: "土",
        week_en: "Saturday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2018-01-01": {
        date: "2018-01-01",
        week: "月",
        week_en: "Monday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2018-01-08": {
        date: "2018-01-08",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2018-02-11": {
        date: "2018-02-11",
        week: "日",
        week_en: "Sunday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2018-02-12": {
        date: "2018-02-12",
        week: "月",
        week_en: "Monday",
        name: "建国記念の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2018-03-21": {
        date: "2018-03-21",
        week: "水",
        week_en: "Wednesday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2018-04-29": {
        date: "2018-04-29",
        week: "日",
        week_en: "Sunday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2018-04-30": {
        date: "2018-04-30",
        week: "月",
        week_en: "Monday",
        name: "昭和の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2018-05-03": {
        date: "2018-05-03",
        week: "木",
        week_en: "Thursday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2018-05-04": {
        date: "2018-05-04",
        week: "金",
        week_en: "Friday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2018-05-05": {
        date: "2018-05-05",
        week: "土",
        week_en: "Saturday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2018-07-16": {
        date: "2018-07-16",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2018-08-11": {
        date: "2018-08-11",
        week: "土",
        week_en: "Saturday",
        name: "山の日",
        name_en: "Mountain Day"
    },
    "2018-09-17": {
        date: "2018-09-17",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2018-09-23": {
        date: "2018-09-23",
        week: "日",
        week_en: "Sunday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2018-09-24": {
        date: "2018-09-24",
        week: "月",
        week_en: "Monday",
        name: "秋分の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2018-10-08": {
        date: "2018-10-08",
        week: "月",
        week_en: "Monday",
        name: "体育の日",
        name_en: "Health and Sports Day"
    },
    "2018-11-03": {
        date: "2018-11-03",
        week: "土",
        week_en: "Saturday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2018-11-23": {
        date: "2018-11-23",
        week: "金",
        week_en: "Friday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2018-12-23": {
        date: "2018-12-23",
        week: "日",
        week_en: "Sunday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2018-12-24": {
        date: "2018-12-24",
        week: "月",
        week_en: "Monday",
        name: "天皇誕生日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2019-01-01": {
        date: "2019-01-01",
        week: "火",
        week_en: "Tuesday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2019-01-14": {
        date: "2019-01-14",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2019-02-11": {
        date: "2019-02-11",
        week: "月",
        week_en: "Monday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2019-03-21": {
        date: "2019-03-21",
        week: "木",
        week_en: "Thursday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2019-04-29": {
        date: "2019-04-29",
        week: "月",
        week_en: "Monday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2019-04-30": {
        date: "2019-04-30",
        week: "火",
        week_en: "Tuesday",
        name: "休日",
        name_en: "Holiday"
    },
    "2019-05-01": {
        date: "2019-05-01",
        week: "水",
        week_en: "Wednesday",
        name: "休日（祝日扱い）",
        name_en: "Holiday"
    },
    "2019-05-02": {
        date: "2019-05-02",
        week: "木",
        week_en: "Thursday",
        name: "休日",
        name_en: "Holiday"
    },
    "2019-05-03": {
        date: "2019-05-03",
        week: "金",
        week_en: "Friday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2019-05-04": {
        date: "2019-05-04",
        week: "土",
        week_en: "Saturday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2019-05-05": {
        date: "2019-05-05",
        week: "日",
        week_en: "Sunday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2019-05-06": {
        date: "2019-05-06",
        week: "月",
        week_en: "Monday",
        name: "こどもの日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2019-07-15": {
        date: "2019-07-15",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2019-08-11": {
        date: "2019-08-11",
        week: "日",
        week_en: "Sunday",
        name: "山の日",
        name_en: "Mountain Day"
    },
    "2019-08-12": {
        date: "2019-08-12",
        week: "月",
        week_en: "Monday",
        name: "山の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2019-09-16": {
        date: "2019-09-16",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2019-09-23": {
        date: "2019-09-23",
        week: "月",
        week_en: "Monday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2019-10-14": {
        date: "2019-10-14",
        week: "月",
        week_en: "Monday",
        name: "体育の日（スポーツの日）",
        name_en: "Health and Sports Day"
    },
    "2019-10-22": {
        date: "2019-10-22",
        week: "火",
        week_en: "Tuesday",
        name: "休日（祝日扱い）",
        name_en: "Holiday"
    },
    "2019-11-03": {
        date: "2019-11-03",
        week: "日",
        week_en: "Sunday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2019-11-04": {
        date: "2019-11-04",
        week: "月",
        week_en: "Monday",
        name: "文化の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2019-11-23": {
        date: "2019-11-23",
        week: "土",
        week_en: "Saturday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2020-01-01": {
        date: "2020-01-01",
        week: "水",
        week_en: "Wednesday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2020-01-13": {
        date: "2020-01-13",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2020-02-11": {
        date: "2020-02-11",
        week: "火",
        week_en: "Tuesday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2020-02-23": {
        date: "2020-02-23",
        week: "日",
        week_en: "Sunday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2020-02-24": {
        date: "2020-02-24",
        week: "月",
        week_en: "Monday",
        name: "天皇誕生日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2020-03-20": {
        date: "2020-03-20",
        week: "金",
        week_en: "Friday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2020-04-29": {
        date: "2020-04-29",
        week: "水",
        week_en: "Wednesday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2020-05-03": {
        date: "2020-05-03",
        week: "日",
        week_en: "Sunday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2020-05-04": {
        date: "2020-05-04",
        week: "月",
        week_en: "Monday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2020-05-05": {
        date: "2020-05-05",
        week: "火",
        week_en: "Tuesday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2020-05-06": {
        date: "2020-05-06",
        week: "水",
        week_en: "Wednesday",
        name: "憲法記念日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2020-07-23": {
        date: "2020-07-23",
        week: "木",
        week_en: "Thursday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2020-07-24": {
        date: "2020-07-24",
        week: "金",
        week_en: "Friday",
        name: "スポーツの日",
        name_en: "Health and Sports Day"
    },
    "2020-08-10": {
        date: "2020-08-10",
        week: "月",
        week_en: "Monday",
        name: "山の日",
        name_en: "Mountain Day"
    },
    "2020-09-21": {
        date: "2020-09-21",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2020-09-22": {
        date: "2020-09-22",
        week: "火",
        week_en: "Tuesday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2020-11-03": {
        date: "2020-11-03",
        week: "火",
        week_en: "Tuesday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2020-11-23": {
        date: "2020-11-23",
        week: "月",
        week_en: "Monday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2021-01-01": {
        date: "2021-01-01",
        week: "金",
        week_en: "Friday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2021-01-11": {
        date: "2021-01-11",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2021-02-11": {
        date: "2021-02-11",
        week: "木",
        week_en: "Thursday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2021-02-23": {
        date: "2021-02-23",
        week: "火",
        week_en: "Tuesday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2021-03-20": {
        date: "2021-03-20",
        week: "土",
        week_en: "Saturday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2021-04-29": {
        date: "2021-04-29",
        week: "木",
        week_en: "Thursday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2021-05-03": {
        date: "2021-05-03",
        week: "月",
        week_en: "Monday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2021-05-04": {
        date: "2021-05-04",
        week: "火",
        week_en: "Tuesday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2021-05-05": {
        date: "2021-05-05",
        week: "水",
        week_en: "Wednesday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2021-07-22": {
        date: "2021-07-22",
        week: "木",
        week_en: "Thursday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2021-07-23": {
        date: "2021-07-23",
        week: "金",
        week_en: "Friday",
        name: "スポーツの日",
        name_en: "Health and Sports Day"
    },
    "2021-08-08": {
        date: "2021-08-08",
        week: "日",
        week_en: "Sunday",
        name: "山の日",
        name_en: "Mountain Day"
    },
    "2021-08-09": {
        date: "2021-08-09",
        week: "月",
        week_en: "Monday",
        name: "山の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2021-09-20": {
        date: "2021-09-20",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2021-09-23": {
        date: "2021-09-23",
        week: "木",
        week_en: "Thursday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2021-11-03": {
        date: "2021-11-03",
        week: "水",
        week_en: "Wednesday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2021-11-23": {
        date: "2021-11-23",
        week: "火",
        week_en: "Tuesday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2022-01-01": {
        date: "2022-01-01",
        week: "土",
        week_en: "Saturday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2022-01-10": {
        date: "2022-01-10",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2022-02-11": {
        date: "2022-02-11",
        week: "金",
        week_en: "Friday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2022-02-23": {
        date: "2022-02-23",
        week: "水",
        week_en: "Wednesday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2022-03-21": {
        date: "2022-03-21",
        week: "月",
        week_en: "Monday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2022-04-29": {
        date: "2022-04-29",
        week: "金",
        week_en: "Friday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2022-05-03": {
        date: "2022-05-03",
        week: "火",
        week_en: "Tuesday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2022-05-04": {
        date: "2022-05-04",
        week: "水",
        week_en: "Wednesday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2022-05-05": {
        date: "2022-05-05",
        week: "木",
        week_en: "Thursday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2022-07-18": {
        date: "2022-07-18",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2022-08-11": {
        date: "2022-08-11",
        week: "木",
        week_en: "Thursday",
        name: "山の日",
        name_en: "Mountain Day"
    },
    "2022-09-19": {
        date: "2022-09-19",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2022-09-23": {
        date: "2022-09-23",
        week: "金",
        week_en: "Friday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2022-10-10": {
        date: "2022-10-10",
        week: "月",
        week_en: "Monday",
        name: "スポーツの日",
        name_en: "Health and Sports Day"
    },
    "2022-11-03": {
        date: "2022-11-03",
        week: "木",
        week_en: "Thursday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2022-11-23": {
        date: "2022-11-23",
        week: "水",
        week_en: "Wednesday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2023-01-01": {
        date: "2023-01-01",
        week: "日",
        week_en: "Sunday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2023-01-02": {
        date: "2023-01-02",
        week: "月",
        week_en: "Monday",
        name: "元日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2023-01-09": {
        date: "2023-01-09",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2023-02-11": {
        date: "2023-02-11",
        week: "土",
        week_en: "Saturday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2023-02-23": {
        date: "2023-02-23",
        week: "木",
        week_en: "Thursday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2023-03-21": {
        date: "2023-03-21",
        week: "火",
        week_en: "Tuesday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2023-04-29": {
        date: "2023-04-29",
        week: "土",
        week_en: "Saturday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2023-05-03": {
        date: "2023-05-03",
        week: "水",
        week_en: "Wednesday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2023-05-04": {
        date: "2023-05-04",
        week: "木",
        week_en: "Thursday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2023-05-05": {
        date: "2023-05-05",
        week: "金",
        week_en: "Friday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2023-07-17": {
        date: "2023-07-17",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2023-08-11": {
        date: "2023-08-11",
        week: "金",
        week_en: "Friday",
        name: "山の日",
        name_en: "Mountain Day"
    },
    "2023-09-18": {
        date: "2023-09-18",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2023-09-23": {
        date: "2023-09-23",
        week: "土",
        week_en: "Saturday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2023-10-09": {
        date: "2023-10-09",
        week: "月",
        week_en: "Monday",
        name: "スポーツの日",
        name_en: "Health and Sports Day"
    },
    "2023-11-03": {
        date: "2023-11-03",
        week: "金",
        week_en: "Friday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2023-11-23": {
        date: "2023-11-23",
        week: "木",
        week_en: "Thursday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2024-01-01": {
        date: "2024-01-01",
        week: "月",
        week_en: "Monday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2024-01-08": {
        date: "2024-01-08",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2024-02-11": {
        date: "2024-02-11",
        week: "日",
        week_en: "Sunday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2024-02-12": {
        date: "2024-02-12",
        week: "月",
        week_en: "Monday",
        name: "建国記念の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2024-02-23": {
        date: "2024-02-23",
        week: "金",
        week_en: "Friday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2024-03-20": {
        date: "2024-03-20",
        week: "水",
        week_en: "Wednesday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2024-04-29": {
        date: "2024-04-29",
        week: "月",
        week_en: "Monday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2024-05-03": {
        date: "2024-05-03",
        week: "金",
        week_en: "Friday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2024-05-04": {
        date: "2024-05-04",
        week: "土",
        week_en: "Saturday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2024-05-05": {
        date: "2024-05-05",
        week: "日",
        week_en: "Sunday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2024-05-06": {
        date: "2024-05-06",
        week: "月",
        week_en: "Monday",
        name: "こどもの日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2024-07-15": {
        date: "2024-07-15",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2024-08-11": {
        date: "2024-08-11",
        week: "日",
        week_en: "Sunday",
        name: "山の日",
        name_en: "Mountain Day"
    },
    "2024-08-12": {
        date: "2024-08-12",
        week: "月",
        week_en: "Monday",
        name: "山の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2024-09-16": {
        date: "2024-09-16",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2024-09-22": {
        date: "2024-09-22",
        week: "日",
        week_en: "Sunday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2024-09-23": {
        date: "2024-09-23",
        week: "月",
        week_en: "Monday",
        name: "秋分の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2024-10-14": {
        date: "2024-10-14",
        week: "月",
        week_en: "Monday",
        name: "スポーツの日",
        name_en: "Health and Sports Day"
    },
    "2024-11-03": {
        date: "2024-11-03",
        week: "日",
        week_en: "Sunday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2024-11-04": {
        date: "2024-11-04",
        week: "月",
        week_en: "Monday",
        name: "文化の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2024-11-23": {
        date: "2024-11-23",
        week: "土",
        week_en: "Saturday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2025-01-01": {
        date: "2025-01-01",
        week: "水",
        week_en: "Wednesday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2025-01-13": {
        date: "2025-01-13",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2025-02-11": {
        date: "2025-02-11",
        week: "火",
        week_en: "Tuesday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2025-02-23": {
        date: "2025-02-23",
        week: "日",
        week_en: "Sunday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2025-02-24": {
        date: "2025-02-24",
        week: "月",
        week_en: "Monday",
        name: "天皇誕生日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2025-03-20": {
        date: "2025-03-20",
        week: "木",
        week_en: "Thursday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2025-04-29": {
        date: "2025-04-29",
        week: "火",
        week_en: "Tuesday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2025-05-03": {
        date: "2025-05-03",
        week: "土",
        week_en: "Saturday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2025-05-04": {
        date: "2025-05-04",
        week: "日",
        week_en: "Sunday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2025-05-05": {
        date: "2025-05-05",
        week: "月",
        week_en: "Monday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2025-05-06": {
        date: "2025-05-06",
        week: "火",
        week_en: "Tuesday",
        name: "こどもの日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2025-07-21": {
        date: "2025-07-21",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2025-08-11": {
        date: "2025-08-11",
        week: "月",
        week_en: "Monday",
        name: "山の日",
        name_en: "Mountain Day"
    },
    "2025-09-15": {
        date: "2025-09-15",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2025-09-23": {
        date: "2025-09-23",
        week: "火",
        week_en: "Tuesday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2025-10-13": {
        date: "2025-10-13",
        week: "月",
        week_en: "Monday",
        name: "スポーツの日",
        name_en: "Health and Sports Day"
    },
    "2025-11-03": {
        date: "2025-11-03",
        week: "月",
        week_en: "Monday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2025-11-23": {
        date: "2025-11-23",
        week: "日",
        week_en: "Sunday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2025-11-24": {
        date: "2025-11-24",
        week: "月",
        week_en: "Monday",
        name: "勤労感謝の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2026-01-01": {
        date: "2026-01-01",
        week: "木",
        week_en: "Thursday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2026-01-12": {
        date: "2026-01-12",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2026-02-11": {
        date: "2026-02-11",
        week: "水",
        week_en: "Wednesday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2026-02-23": {
        date: "2026-02-23",
        week: "月",
        week_en: "Monday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2026-03-20": {
        date: "2026-03-20",
        week: "金",
        week_en: "Friday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2026-04-29": {
        date: "2026-04-29",
        week: "水",
        week_en: "Wednesday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2026-05-03": {
        date: "2026-05-03",
        week: "日",
        week_en: "Sunday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2026-05-04": {
        date: "2026-05-04",
        week: "月",
        week_en: "Monday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2026-05-05": {
        date: "2026-05-05",
        week: "火",
        week_en: "Tuesday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2026-05-06": {
        date: "2026-05-06",
        week: "水",
        week_en: "Wednesday",
        name: "こどもの日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2026-07-20": {
        date: "2026-07-20",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2026-08-11": {
        date: "2026-08-11",
        week: "火",
        week_en: "Tuesday",
        name: "山の日",
        name_en: "Mountain Day"
    },
    "2026-09-21": {
        date: "2026-09-21",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2026-09-22": {
        date: "2026-09-22",
        week: "火",
        week_en: "Tuesday",
        name: "休日",
        name_en: "Citizen's Holiday"
    },
    "2026-09-23": {
        date: "2026-09-23",
        week: "水",
        week_en: "Wednesday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2026-10-12": {
        date: "2026-10-12",
        week: "月",
        week_en: "Monday",
        name: "スポーツの日",
        name_en: "Health and Sports Day"
    },
    "2026-11-03": {
        date: "2026-11-03",
        week: "火",
        week_en: "Tuesday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2026-11-23": {
        date: "2026-11-23",
        week: "月",
        week_en: "Monday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2027-01-01": {
        date: "2027-01-01",
        week: "金",
        week_en: "Friday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2027-01-11": {
        date: "2027-01-11",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2027-02-11": {
        date: "2027-02-11",
        week: "木",
        week_en: "Thursday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2027-02-23": {
        date: "2027-02-23",
        week: "火",
        week_en: "Tuesday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2027-03-21": {
        date: "2027-03-21",
        week: "日",
        week_en: "Sunday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2027-03-22": {
        date: "2027-03-22",
        week: "月",
        week_en: "Monday",
        name: "春分の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2027-04-29": {
        date: "2027-04-29",
        week: "木",
        week_en: "Thursday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2027-05-03": {
        date: "2027-05-03",
        week: "月",
        week_en: "Monday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2027-05-04": {
        date: "2027-05-04",
        week: "火",
        week_en: "Tuesday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2027-05-05": {
        date: "2027-05-05",
        week: "水",
        week_en: "Wednesday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2027-07-19": {
        date: "2027-07-19",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2027-08-11": {
        date: "2027-08-11",
        week: "水",
        week_en: "Wednesday",
        name: "山の日",
        name_en: "Mountain Day"
    },
    "2027-09-20": {
        date: "2027-09-20",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2027-09-23": {
        date: "2027-09-23",
        week: "木",
        week_en: "Thursday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2027-10-11": {
        date: "2027-10-11",
        week: "月",
        week_en: "Monday",
        name: "スポーツの日",
        name_en: "Health and Sports Day"
    },
    "2027-11-03": {
        date: "2027-11-03",
        week: "水",
        week_en: "Wednesday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2027-11-23": {
        date: "2027-11-23",
        week: "火",
        week_en: "Tuesday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2028-01-01": {
        date: "2028-01-01",
        week: "土",
        week_en: "Saturday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2028-01-10": {
        date: "2028-01-10",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2028-02-11": {
        date: "2028-02-11",
        week: "金",
        week_en: "Friday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2028-02-23": {
        date: "2028-02-23",
        week: "水",
        week_en: "Wednesday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2028-03-20": {
        date: "2028-03-20",
        week: "月",
        week_en: "Monday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2028-04-29": {
        date: "2028-04-29",
        week: "土",
        week_en: "Saturday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2028-05-03": {
        date: "2028-05-03",
        week: "水",
        week_en: "Wednesday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2028-05-04": {
        date: "2028-05-04",
        week: "木",
        week_en: "Thursday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2028-05-05": {
        date: "2028-05-05",
        week: "金",
        week_en: "Friday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2028-07-17": {
        date: "2028-07-17",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2028-08-11": {
        date: "2028-08-11",
        week: "金",
        week_en: "Friday",
        name: "山の日",
        name_en: "Mountain Day"
    },
    "2028-09-18": {
        date: "2028-09-18",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2028-09-22": {
        date: "2028-09-22",
        week: "金",
        week_en: "Friday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2028-10-09": {
        date: "2028-10-09",
        week: "月",
        week_en: "Monday",
        name: "スポーツの日",
        name_en: "Health and Sports Day"
    },
    "2028-11-03": {
        date: "2028-11-03",
        week: "金",
        week_en: "Friday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2028-11-23": {
        date: "2028-11-23",
        week: "木",
        week_en: "Thursday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2029-01-01": {
        date: "2029-01-01",
        week: "月",
        week_en: "Monday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2029-01-08": {
        date: "2029-01-08",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2029-02-11": {
        date: "2029-02-11",
        week: "日",
        week_en: "Sunday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2029-02-12": {
        date: "2029-02-12",
        week: "月",
        week_en: "Monday",
        name: "建国記念の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2029-02-23": {
        date: "2029-02-23",
        week: "金",
        week_en: "Friday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2029-03-20": {
        date: "2029-03-20",
        week: "火",
        week_en: "Tuesday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2029-04-29": {
        date: "2029-04-29",
        week: "日",
        week_en: "Sunday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2029-04-30": {
        date: "2029-04-30",
        week: "月",
        week_en: "Monday",
        name: "昭和の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2029-05-03": {
        date: "2029-05-03",
        week: "木",
        week_en: "Thursday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2029-05-04": {
        date: "2029-05-04",
        week: "金",
        week_en: "Friday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2029-05-05": {
        date: "2029-05-05",
        week: "土",
        week_en: "Saturday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2029-07-16": {
        date: "2029-07-16",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2029-08-11": {
        date: "2029-08-11",
        week: "土",
        week_en: "Saturday",
        name: "山の日",
        name_en: "Mountain Day"
    },
    "2029-09-17": {
        date: "2029-09-17",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2029-09-23": {
        date: "2029-09-23",
        week: "日",
        week_en: "Sunday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2029-09-24": {
        date: "2029-09-24",
        week: "月",
        week_en: "Monday",
        name: "秋分の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2029-10-08": {
        date: "2029-10-08",
        week: "月",
        week_en: "Monday",
        name: "スポーツの日",
        name_en: "Health and Sports Day"
    },
    "2029-11-03": {
        date: "2029-11-03",
        week: "土",
        week_en: "Saturday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2029-11-23": {
        date: "2029-11-23",
        week: "金",
        week_en: "Friday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2030-01-01": {
        date: "2030-01-01",
        week: "火",
        week_en: "Tuesday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2030-01-14": {
        date: "2030-01-14",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2030-02-11": {
        date: "2030-02-11",
        week: "月",
        week_en: "Monday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2030-02-23": {
        date: "2030-02-23",
        week: "土",
        week_en: "Saturday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2030-03-20": {
        date: "2030-03-20",
        week: "水",
        week_en: "Wednesday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2030-04-29": {
        date: "2030-04-29",
        week: "月",
        week_en: "Monday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2030-05-03": {
        date: "2030-05-03",
        week: "金",
        week_en: "Friday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2030-05-04": {
        date: "2030-05-04",
        week: "土",
        week_en: "Saturday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2030-05-05": {
        date: "2030-05-05",
        week: "日",
        week_en: "Sunday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2030-05-06": {
        date: "2030-05-06",
        week: "月",
        week_en: "Monday",
        name: "こどもの日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2030-07-15": {
        date: "2030-07-15",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2030-08-11": {
        date: "2030-08-11",
        week: "日",
        week_en: "Sunday",
        name: "山の日",
        name_en: "Mountain Day"
    },
    "2030-08-12": {
        date: "2030-08-12",
        week: "月",
        week_en: "Monday",
        name: "山の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2030-09-16": {
        date: "2030-09-16",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2030-09-23": {
        date: "2030-09-23",
        week: "月",
        week_en: "Monday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2030-10-14": {
        date: "2030-10-14",
        week: "月",
        week_en: "Monday",
        name: "スポーツの日",
        name_en: "Health and Sports Day"
    },
    "2030-11-03": {
        date: "2030-11-03",
        week: "日",
        week_en: "Sunday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2030-11-04": {
        date: "2030-11-04",
        week: "月",
        week_en: "Monday",
        name: "文化の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2030-11-23": {
        date: "2030-11-23",
        week: "土",
        week_en: "Saturday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2031-01-01": {
        date: "2031-01-01",
        week: "水",
        week_en: "Wednesday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2031-01-13": {
        date: "2031-01-13",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2031-02-11": {
        date: "2031-02-11",
        week: "火",
        week_en: "Tuesday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2031-02-23": {
        date: "2031-02-23",
        week: "日",
        week_en: "Sunday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2031-02-24": {
        date: "2031-02-24",
        week: "月",
        week_en: "Monday",
        name: "天皇誕生日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2031-03-21": {
        date: "2031-03-21",
        week: "金",
        week_en: "Friday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2031-04-29": {
        date: "2031-04-29",
        week: "火",
        week_en: "Tuesday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2031-05-03": {
        date: "2031-05-03",
        week: "土",
        week_en: "Saturday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2031-05-04": {
        date: "2031-05-04",
        week: "日",
        week_en: "Sunday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2031-05-05": {
        date: "2031-05-05",
        week: "月",
        week_en: "Monday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2031-05-06": {
        date: "2031-05-06",
        week: "火",
        week_en: "Tuesday",
        name: "こどもの日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2031-07-21": {
        date: "2031-07-21",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2031-08-11": {
        date: "2031-08-11",
        week: "月",
        week_en: "Monday",
        name: "山の日",
        name_en: "Mountain Day"
    },
    "2031-09-15": {
        date: "2031-09-15",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2031-09-23": {
        date: "2031-09-23",
        week: "火",
        week_en: "Tuesday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2031-10-13": {
        date: "2031-10-13",
        week: "月",
        week_en: "Monday",
        name: "スポーツの日",
        name_en: "Health and Sports Day"
    },
    "2031-11-03": {
        date: "2031-11-03",
        week: "月",
        week_en: "Monday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2031-11-23": {
        date: "2031-11-23",
        week: "日",
        week_en: "Sunday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2031-11-24": {
        date: "2031-11-24",
        week: "月",
        week_en: "Monday",
        name: "勤労感謝の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2032-01-01": {
        date: "2032-01-01",
        week: "木",
        week_en: "Thursday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2032-01-12": {
        date: "2032-01-12",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2032-02-11": {
        date: "2032-02-11",
        week: "水",
        week_en: "Wednesday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2032-02-23": {
        date: "2032-02-23",
        week: "月",
        week_en: "Monday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2032-03-20": {
        date: "2032-03-20",
        week: "土",
        week_en: "Saturday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2032-04-29": {
        date: "2032-04-29",
        week: "木",
        week_en: "Thursday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2032-05-03": {
        date: "2032-05-03",
        week: "月",
        week_en: "Monday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2032-05-04": {
        date: "2032-05-04",
        week: "火",
        week_en: "Tuesday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2032-05-05": {
        date: "2032-05-05",
        week: "水",
        week_en: "Wednesday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2032-07-19": {
        date: "2032-07-19",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2032-08-11": {
        date: "2032-08-11",
        week: "水",
        week_en: "Wednesday",
        name: "山の日",
        name_en: "Mountain Day"
    },
    "2032-09-20": {
        date: "2032-09-20",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2032-09-21": {
        date: "2032-09-21",
        week: "火",
        week_en: "Tuesday",
        name: "休日",
        name_en: "Citizen's Holiday"
    },
    "2032-09-22": {
        date: "2032-09-22",
        week: "水",
        week_en: "Wednesday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2032-10-11": {
        date: "2032-10-11",
        week: "月",
        week_en: "Monday",
        name: "スポーツの日",
        name_en: "Health and Sports Day"
    },
    "2032-11-03": {
        date: "2032-11-03",
        week: "水",
        week_en: "Wednesday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2032-11-23": {
        date: "2032-11-23",
        week: "火",
        week_en: "Tuesday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2033-01-01": {
        date: "2033-01-01",
        week: "土",
        week_en: "Saturday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2033-01-10": {
        date: "2033-01-10",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2033-02-11": {
        date: "2033-02-11",
        week: "金",
        week_en: "Friday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2033-02-23": {
        date: "2033-02-23",
        week: "水",
        week_en: "Wednesday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2033-03-20": {
        date: "2033-03-20",
        week: "日",
        week_en: "Sunday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2033-03-21": {
        date: "2033-03-21",
        week: "月",
        week_en: "Monday",
        name: "春分の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2033-04-29": {
        date: "2033-04-29",
        week: "金",
        week_en: "Friday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2033-05-03": {
        date: "2033-05-03",
        week: "火",
        week_en: "Tuesday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2033-05-04": {
        date: "2033-05-04",
        week: "水",
        week_en: "Wednesday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2033-05-05": {
        date: "2033-05-05",
        week: "木",
        week_en: "Thursday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2033-07-18": {
        date: "2033-07-18",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2033-08-11": {
        date: "2033-08-11",
        week: "木",
        week_en: "Thursday",
        name: "山の日",
        name_en: "Mountain Day"
    },
    "2033-09-19": {
        date: "2033-09-19",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2033-09-23": {
        date: "2033-09-23",
        week: "金",
        week_en: "Friday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2033-10-10": {
        date: "2033-10-10",
        week: "月",
        week_en: "Monday",
        name: "スポーツの日",
        name_en: "Health and Sports Day"
    },
    "2033-11-03": {
        date: "2033-11-03",
        week: "木",
        week_en: "Thursday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2033-11-23": {
        date: "2033-11-23",
        week: "水",
        week_en: "Wednesday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2034-01-01": {
        date: "2034-01-01",
        week: "日",
        week_en: "Sunday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2034-01-02": {
        date: "2034-01-02",
        week: "月",
        week_en: "Monday",
        name: "元日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2034-01-09": {
        date: "2034-01-09",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2034-02-11": {
        date: "2034-02-11",
        week: "土",
        week_en: "Saturday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2034-02-23": {
        date: "2034-02-23",
        week: "木",
        week_en: "Thursday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2034-03-20": {
        date: "2034-03-20",
        week: "月",
        week_en: "Monday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2034-04-29": {
        date: "2034-04-29",
        week: "土",
        week_en: "Saturday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2034-05-03": {
        date: "2034-05-03",
        week: "水",
        week_en: "Wednesday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2034-05-04": {
        date: "2034-05-04",
        week: "木",
        week_en: "Thursday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2034-05-05": {
        date: "2034-05-05",
        week: "金",
        week_en: "Friday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2034-07-17": {
        date: "2034-07-17",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2034-08-11": {
        date: "2034-08-11",
        week: "金",
        week_en: "Friday",
        name: "山の日",
        name_en: "Mountain Day"
    },
    "2034-09-18": {
        date: "2034-09-18",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2034-09-23": {
        date: "2034-09-23",
        week: "土",
        week_en: "Saturday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2034-10-09": {
        date: "2034-10-09",
        week: "月",
        week_en: "Monday",
        name: "スポーツの日",
        name_en: "Health and Sports Day"
    },
    "2034-11-03": {
        date: "2034-11-03",
        week: "金",
        week_en: "Friday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2034-11-23": {
        date: "2034-11-23",
        week: "木",
        week_en: "Thursday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2035-01-01": {
        date: "2035-01-01",
        week: "月",
        week_en: "Monday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2035-01-08": {
        date: "2035-01-08",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2035-02-11": {
        date: "2035-02-11",
        week: "日",
        week_en: "Sunday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2035-02-12": {
        date: "2035-02-12",
        week: "月",
        week_en: "Monday",
        name: "建国記念の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2035-02-23": {
        date: "2035-02-23",
        week: "金",
        week_en: "Friday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2035-03-21": {
        date: "2035-03-21",
        week: "水",
        week_en: "Wednesday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2035-04-29": {
        date: "2035-04-29",
        week: "日",
        week_en: "Sunday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2035-04-30": {
        date: "2035-04-30",
        week: "月",
        week_en: "Monday",
        name: "昭和の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2035-05-03": {
        date: "2035-05-03",
        week: "木",
        week_en: "Thursday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2035-05-04": {
        date: "2035-05-04",
        week: "金",
        week_en: "Friday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2035-05-05": {
        date: "2035-05-05",
        week: "土",
        week_en: "Saturday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2035-07-16": {
        date: "2035-07-16",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2035-08-11": {
        date: "2035-08-11",
        week: "土",
        week_en: "Saturday",
        name: "山の日",
        name_en: "Mountain Day"
    },
    "2035-09-17": {
        date: "2035-09-17",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2035-09-23": {
        date: "2035-09-23",
        week: "日",
        week_en: "Sunday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2035-09-24": {
        date: "2035-09-24",
        week: "月",
        week_en: "Monday",
        name: "秋分の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2035-10-08": {
        date: "2035-10-08",
        week: "月",
        week_en: "Monday",
        name: "スポーツの日",
        name_en: "Health and Sports Day"
    },
    "2035-11-03": {
        date: "2035-11-03",
        week: "土",
        week_en: "Saturday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2035-11-23": {
        date: "2035-11-23",
        week: "金",
        week_en: "Friday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2036-01-01": {
        date: "2036-01-01",
        week: "火",
        week_en: "Tuesday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2036-01-14": {
        date: "2036-01-14",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2036-02-11": {
        date: "2036-02-11",
        week: "月",
        week_en: "Monday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2036-02-23": {
        date: "2036-02-23",
        week: "土",
        week_en: "Saturday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2036-03-20": {
        date: "2036-03-20",
        week: "木",
        week_en: "Thursday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2036-04-29": {
        date: "2036-04-29",
        week: "火",
        week_en: "Tuesday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2036-05-03": {
        date: "2036-05-03",
        week: "土",
        week_en: "Saturday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2036-05-04": {
        date: "2036-05-04",
        week: "日",
        week_en: "Sunday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2036-05-05": {
        date: "2036-05-05",
        week: "月",
        week_en: "Monday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2036-05-06": {
        date: "2036-05-06",
        week: "火",
        week_en: "Tuesday",
        name: "こどもの日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2036-07-21": {
        date: "2036-07-21",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2036-08-11": {
        date: "2036-08-11",
        week: "月",
        week_en: "Monday",
        name: "山の日",
        name_en: "Mountain Day"
    },
    "2036-09-15": {
        date: "2036-09-15",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2036-09-22": {
        date: "2036-09-22",
        week: "月",
        week_en: "Monday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2036-10-13": {
        date: "2036-10-13",
        week: "月",
        week_en: "Monday",
        name: "スポーツの日",
        name_en: "Health and Sports Day"
    },
    "2036-11-03": {
        date: "2036-11-03",
        week: "月",
        week_en: "Monday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2036-11-23": {
        date: "2036-11-23",
        week: "日",
        week_en: "Sunday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2036-11-24": {
        date: "2036-11-24",
        week: "月",
        week_en: "Monday",
        name: "勤労感謝の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2037-01-01": {
        date: "2037-01-01",
        week: "木",
        week_en: "Thursday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2037-01-12": {
        date: "2037-01-12",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2037-02-11": {
        date: "2037-02-11",
        week: "水",
        week_en: "Wednesday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2037-02-23": {
        date: "2037-02-23",
        week: "月",
        week_en: "Monday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2037-03-20": {
        date: "2037-03-20",
        week: "金",
        week_en: "Friday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2037-04-29": {
        date: "2037-04-29",
        week: "水",
        week_en: "Wednesday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2037-05-03": {
        date: "2037-05-03",
        week: "日",
        week_en: "Sunday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2037-05-04": {
        date: "2037-05-04",
        week: "月",
        week_en: "Monday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2037-05-05": {
        date: "2037-05-05",
        week: "火",
        week_en: "Tuesday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2037-05-06": {
        date: "2037-05-06",
        week: "水",
        week_en: "Wednesday",
        name: "こどもの日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2037-07-20": {
        date: "2037-07-20",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2037-08-11": {
        date: "2037-08-11",
        week: "火",
        week_en: "Tuesday",
        name: "山の日",
        name_en: "Mountain Day"
    },
    "2037-09-21": {
        date: "2037-09-21",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2037-09-22": {
        date: "2037-09-22",
        week: "火",
        week_en: "Tuesday",
        name: "休日",
        name_en: "Citizen's Holiday"
    },
    "2037-09-23": {
        date: "2037-09-23",
        week: "水",
        week_en: "Wednesday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2037-10-12": {
        date: "2037-10-12",
        week: "月",
        week_en: "Monday",
        name: "スポーツの日",
        name_en: "Health and Sports Day"
    },
    "2037-11-03": {
        date: "2037-11-03",
        week: "火",
        week_en: "Tuesday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2037-11-23": {
        date: "2037-11-23",
        week: "月",
        week_en: "Monday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2038-01-01": {
        date: "2038-01-01",
        week: "金",
        week_en: "Friday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2038-01-11": {
        date: "2038-01-11",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2038-02-11": {
        date: "2038-02-11",
        week: "木",
        week_en: "Thursday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2038-02-23": {
        date: "2038-02-23",
        week: "火",
        week_en: "Tuesday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2038-03-20": {
        date: "2038-03-20",
        week: "土",
        week_en: "Saturday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2038-04-29": {
        date: "2038-04-29",
        week: "木",
        week_en: "Thursday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2038-05-03": {
        date: "2038-05-03",
        week: "月",
        week_en: "Monday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2038-05-04": {
        date: "2038-05-04",
        week: "火",
        week_en: "Tuesday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2038-05-05": {
        date: "2038-05-05",
        week: "水",
        week_en: "Wednesday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2038-07-19": {
        date: "2038-07-19",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2038-08-11": {
        date: "2038-08-11",
        week: "水",
        week_en: "Wednesday",
        name: "山の日",
        name_en: "Mountain Day"
    },
    "2038-09-20": {
        date: "2038-09-20",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2038-09-23": {
        date: "2038-09-23",
        week: "木",
        week_en: "Thursday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2038-10-11": {
        date: "2038-10-11",
        week: "月",
        week_en: "Monday",
        name: "スポーツの日",
        name_en: "Health and Sports Day"
    },
    "2038-11-03": {
        date: "2038-11-03",
        week: "水",
        week_en: "Wednesday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2038-11-23": {
        date: "2038-11-23",
        week: "火",
        week_en: "Tuesday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2039-01-01": {
        date: "2039-01-01",
        week: "土",
        week_en: "Saturday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2039-01-10": {
        date: "2039-01-10",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2039-02-11": {
        date: "2039-02-11",
        week: "金",
        week_en: "Friday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2039-02-23": {
        date: "2039-02-23",
        week: "水",
        week_en: "Wednesday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2039-03-21": {
        date: "2039-03-21",
        week: "月",
        week_en: "Monday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2039-04-29": {
        date: "2039-04-29",
        week: "金",
        week_en: "Friday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2039-05-03": {
        date: "2039-05-03",
        week: "火",
        week_en: "Tuesday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2039-05-04": {
        date: "2039-05-04",
        week: "水",
        week_en: "Wednesday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2039-05-05": {
        date: "2039-05-05",
        week: "木",
        week_en: "Thursday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2039-07-18": {
        date: "2039-07-18",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2039-08-11": {
        date: "2039-08-11",
        week: "木",
        week_en: "Thursday",
        name: "山の日",
        name_en: "Mountain Day"
    },
    "2039-09-19": {
        date: "2039-09-19",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2039-09-23": {
        date: "2039-09-23",
        week: "金",
        week_en: "Friday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2039-10-10": {
        date: "2039-10-10",
        week: "月",
        week_en: "Monday",
        name: "スポーツの日",
        name_en: "Health and Sports Day"
    },
    "2039-11-03": {
        date: "2039-11-03",
        week: "木",
        week_en: "Thursday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2039-11-23": {
        date: "2039-11-23",
        week: "水",
        week_en: "Wednesday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2040-01-01": {
        date: "2040-01-01",
        week: "日",
        week_en: "Sunday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2040-01-02": {
        date: "2040-01-02",
        week: "月",
        week_en: "Monday",
        name: "元日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2040-01-09": {
        date: "2040-01-09",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2040-02-11": {
        date: "2040-02-11",
        week: "土",
        week_en: "Saturday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2040-02-23": {
        date: "2040-02-23",
        week: "木",
        week_en: "Thursday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2040-03-20": {
        date: "2040-03-20",
        week: "火",
        week_en: "Tuesday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2040-04-29": {
        date: "2040-04-29",
        week: "日",
        week_en: "Sunday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2040-04-30": {
        date: "2040-04-30",
        week: "月",
        week_en: "Monday",
        name: "昭和の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2040-05-03": {
        date: "2040-05-03",
        week: "木",
        week_en: "Thursday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2040-05-04": {
        date: "2040-05-04",
        week: "金",
        week_en: "Friday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2040-05-05": {
        date: "2040-05-05",
        week: "土",
        week_en: "Saturday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2040-07-16": {
        date: "2040-07-16",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2040-08-11": {
        date: "2040-08-11",
        week: "土",
        week_en: "Saturday",
        name: "山の日",
        name_en: "Mountain Day"
    },
    "2040-09-17": {
        date: "2040-09-17",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2040-09-22": {
        date: "2040-09-22",
        week: "土",
        week_en: "Saturday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2040-10-08": {
        date: "2040-10-08",
        week: "月",
        week_en: "Monday",
        name: "スポーツの日",
        name_en: "Health and Sports Day"
    },
    "2040-11-03": {
        date: "2040-11-03",
        week: "土",
        week_en: "Saturday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2040-11-23": {
        date: "2040-11-23",
        week: "金",
        week_en: "Friday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2041-01-01": {
        date: "2041-01-01",
        week: "火",
        week_en: "Tuesday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2041-01-14": {
        date: "2041-01-14",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2041-02-11": {
        date: "2041-02-11",
        week: "月",
        week_en: "Monday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2041-02-23": {
        date: "2041-02-23",
        week: "土",
        week_en: "Saturday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2041-03-20": {
        date: "2041-03-20",
        week: "水",
        week_en: "Wednesday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2041-04-29": {
        date: "2041-04-29",
        week: "月",
        week_en: "Monday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2041-05-03": {
        date: "2041-05-03",
        week: "金",
        week_en: "Friday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2041-05-04": {
        date: "2041-05-04",
        week: "土",
        week_en: "Saturday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2041-05-05": {
        date: "2041-05-05",
        week: "日",
        week_en: "Sunday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2041-05-06": {
        date: "2041-05-06",
        week: "月",
        week_en: "Monday",
        name: "こどもの日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2041-07-15": {
        date: "2041-07-15",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2041-08-11": {
        date: "2041-08-11",
        week: "日",
        week_en: "Sunday",
        name: "山の日",
        name_en: "Mountain Day"
    },
    "2041-08-12": {
        date: "2041-08-12",
        week: "月",
        week_en: "Monday",
        name: "山の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2041-09-16": {
        date: "2041-09-16",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2041-09-23": {
        date: "2041-09-23",
        week: "月",
        week_en: "Monday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2041-10-14": {
        date: "2041-10-14",
        week: "月",
        week_en: "Monday",
        name: "スポーツの日",
        name_en: "Health and Sports Day"
    },
    "2041-11-03": {
        date: "2041-11-03",
        week: "日",
        week_en: "Sunday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2041-11-04": {
        date: "2041-11-04",
        week: "月",
        week_en: "Monday",
        name: "文化の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2041-11-23": {
        date: "2041-11-23",
        week: "土",
        week_en: "Saturday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2042-01-01": {
        date: "2042-01-01",
        week: "水",
        week_en: "Wednesday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2042-01-13": {
        date: "2042-01-13",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2042-02-11": {
        date: "2042-02-11",
        week: "火",
        week_en: "Tuesday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2042-02-23": {
        date: "2042-02-23",
        week: "日",
        week_en: "Sunday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2042-02-24": {
        date: "2042-02-24",
        week: "月",
        week_en: "Monday",
        name: "天皇誕生日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2042-03-20": {
        date: "2042-03-20",
        week: "木",
        week_en: "Thursday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2042-04-29": {
        date: "2042-04-29",
        week: "火",
        week_en: "Tuesday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2042-05-03": {
        date: "2042-05-03",
        week: "土",
        week_en: "Saturday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2042-05-04": {
        date: "2042-05-04",
        week: "日",
        week_en: "Sunday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2042-05-05": {
        date: "2042-05-05",
        week: "月",
        week_en: "Monday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2042-05-06": {
        date: "2042-05-06",
        week: "火",
        week_en: "Tuesday",
        name: "こどもの日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2042-07-21": {
        date: "2042-07-21",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2042-08-11": {
        date: "2042-08-11",
        week: "月",
        week_en: "Monday",
        name: "山の日",
        name_en: "Mountain Day"
    },
    "2042-09-15": {
        date: "2042-09-15",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2042-09-23": {
        date: "2042-09-23",
        week: "火",
        week_en: "Tuesday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2042-10-13": {
        date: "2042-10-13",
        week: "月",
        week_en: "Monday",
        name: "スポーツの日",
        name_en: "Health and Sports Day"
    },
    "2042-11-03": {
        date: "2042-11-03",
        week: "月",
        week_en: "Monday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2042-11-23": {
        date: "2042-11-23",
        week: "日",
        week_en: "Sunday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2042-11-24": {
        date: "2042-11-24",
        week: "月",
        week_en: "Monday",
        name: "勤労感謝の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2043-01-01": {
        date: "2043-01-01",
        week: "木",
        week_en: "Thursday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2043-01-12": {
        date: "2043-01-12",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2043-02-11": {
        date: "2043-02-11",
        week: "水",
        week_en: "Wednesday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2043-02-23": {
        date: "2043-02-23",
        week: "月",
        week_en: "Monday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2043-03-21": {
        date: "2043-03-21",
        week: "土",
        week_en: "Saturday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2043-04-29": {
        date: "2043-04-29",
        week: "水",
        week_en: "Wednesday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2043-05-03": {
        date: "2043-05-03",
        week: "日",
        week_en: "Sunday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2043-05-04": {
        date: "2043-05-04",
        week: "月",
        week_en: "Monday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2043-05-05": {
        date: "2043-05-05",
        week: "火",
        week_en: "Tuesday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2043-05-06": {
        date: "2043-05-06",
        week: "水",
        week_en: "Wednesday",
        name: "こどもの日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2043-07-20": {
        date: "2043-07-20",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2043-08-11": {
        date: "2043-08-11",
        week: "火",
        week_en: "Tuesday",
        name: "山の日",
        name_en: "Mountain Day"
    },
    "2043-09-21": {
        date: "2043-09-21",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2043-09-22": {
        date: "2043-09-22",
        week: "火",
        week_en: "Tuesday",
        name: "休日",
        name_en: "Citizen's Holiday"
    },
    "2043-09-23": {
        date: "2043-09-23",
        week: "水",
        week_en: "Wednesday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2043-10-12": {
        date: "2043-10-12",
        week: "月",
        week_en: "Monday",
        name: "スポーツの日",
        name_en: "Health and Sports Day"
    },
    "2043-11-03": {
        date: "2043-11-03",
        week: "火",
        week_en: "Tuesday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2043-11-23": {
        date: "2043-11-23",
        week: "月",
        week_en: "Monday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2044-01-01": {
        date: "2044-01-01",
        week: "金",
        week_en: "Friday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2044-01-11": {
        date: "2044-01-11",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2044-02-11": {
        date: "2044-02-11",
        week: "木",
        week_en: "Thursday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2044-02-23": {
        date: "2044-02-23",
        week: "火",
        week_en: "Tuesday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2044-03-20": {
        date: "2044-03-20",
        week: "日",
        week_en: "Sunday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2044-03-21": {
        date: "2044-03-21",
        week: "月",
        week_en: "Monday",
        name: "春分の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2044-04-29": {
        date: "2044-04-29",
        week: "金",
        week_en: "Friday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2044-05-03": {
        date: "2044-05-03",
        week: "火",
        week_en: "Tuesday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2044-05-04": {
        date: "2044-05-04",
        week: "水",
        week_en: "Wednesday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2044-05-05": {
        date: "2044-05-05",
        week: "木",
        week_en: "Thursday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2044-07-18": {
        date: "2044-07-18",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2044-08-11": {
        date: "2044-08-11",
        week: "木",
        week_en: "Thursday",
        name: "山の日",
        name_en: "Mountain Day"
    },
    "2044-09-19": {
        date: "2044-09-19",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2044-09-22": {
        date: "2044-09-22",
        week: "木",
        week_en: "Thursday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2044-10-10": {
        date: "2044-10-10",
        week: "月",
        week_en: "Monday",
        name: "スポーツの日",
        name_en: "Health and Sports Day"
    },
    "2044-11-03": {
        date: "2044-11-03",
        week: "木",
        week_en: "Thursday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2044-11-23": {
        date: "2044-11-23",
        week: "水",
        week_en: "Wednesday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2045-01-01": {
        date: "2045-01-01",
        week: "日",
        week_en: "Sunday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2045-01-02": {
        date: "2045-01-02",
        week: "月",
        week_en: "Monday",
        name: "元日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2045-01-09": {
        date: "2045-01-09",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2045-02-11": {
        date: "2045-02-11",
        week: "土",
        week_en: "Saturday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2045-02-23": {
        date: "2045-02-23",
        week: "木",
        week_en: "Thursday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2045-03-20": {
        date: "2045-03-20",
        week: "月",
        week_en: "Monday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2045-04-29": {
        date: "2045-04-29",
        week: "土",
        week_en: "Saturday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2045-05-03": {
        date: "2045-05-03",
        week: "水",
        week_en: "Wednesday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2045-05-04": {
        date: "2045-05-04",
        week: "木",
        week_en: "Thursday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2045-05-05": {
        date: "2045-05-05",
        week: "金",
        week_en: "Friday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2045-07-17": {
        date: "2045-07-17",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2045-08-11": {
        date: "2045-08-11",
        week: "金",
        week_en: "Friday",
        name: "山の日",
        name_en: "Mountain Day"
    },
    "2045-09-18": {
        date: "2045-09-18",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2045-09-22": {
        date: "2045-09-22",
        week: "金",
        week_en: "Friday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2045-10-09": {
        date: "2045-10-09",
        week: "月",
        week_en: "Monday",
        name: "スポーツの日",
        name_en: "Health and Sports Day"
    },
    "2045-11-03": {
        date: "2045-11-03",
        week: "金",
        week_en: "Friday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2045-11-23": {
        date: "2045-11-23",
        week: "木",
        week_en: "Thursday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2046-01-01": {
        date: "2046-01-01",
        week: "月",
        week_en: "Monday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2046-01-08": {
        date: "2046-01-08",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2046-02-11": {
        date: "2046-02-11",
        week: "日",
        week_en: "Sunday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2046-02-12": {
        date: "2046-02-12",
        week: "月",
        week_en: "Monday",
        name: "建国記念の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2046-02-23": {
        date: "2046-02-23",
        week: "金",
        week_en: "Friday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2046-03-20": {
        date: "2046-03-20",
        week: "火",
        week_en: "Tuesday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2046-04-29": {
        date: "2046-04-29",
        week: "日",
        week_en: "Sunday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2046-04-30": {
        date: "2046-04-30",
        week: "月",
        week_en: "Monday",
        name: "昭和の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2046-05-03": {
        date: "2046-05-03",
        week: "木",
        week_en: "Thursday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2046-05-04": {
        date: "2046-05-04",
        week: "金",
        week_en: "Friday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2046-05-05": {
        date: "2046-05-05",
        week: "土",
        week_en: "Saturday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2046-07-16": {
        date: "2046-07-16",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2046-08-11": {
        date: "2046-08-11",
        week: "土",
        week_en: "Saturday",
        name: "山の日",
        name_en: "Mountain Day"
    },
    "2046-09-17": {
        date: "2046-09-17",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2046-09-23": {
        date: "2046-09-23",
        week: "日",
        week_en: "Sunday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2046-09-24": {
        date: "2046-09-24",
        week: "月",
        week_en: "Monday",
        name: "秋分の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2046-10-08": {
        date: "2046-10-08",
        week: "月",
        week_en: "Monday",
        name: "スポーツの日",
        name_en: "Health and Sports Day"
    },
    "2046-11-03": {
        date: "2046-11-03",
        week: "土",
        week_en: "Saturday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2046-11-23": {
        date: "2046-11-23",
        week: "金",
        week_en: "Friday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2047-01-01": {
        date: "2047-01-01",
        week: "火",
        week_en: "Tuesday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2047-01-14": {
        date: "2047-01-14",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2047-02-11": {
        date: "2047-02-11",
        week: "月",
        week_en: "Monday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2047-02-23": {
        date: "2047-02-23",
        week: "土",
        week_en: "Saturday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2047-03-21": {
        date: "2047-03-21",
        week: "木",
        week_en: "Thursday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2047-04-29": {
        date: "2047-04-29",
        week: "月",
        week_en: "Monday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2047-05-03": {
        date: "2047-05-03",
        week: "金",
        week_en: "Friday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2047-05-04": {
        date: "2047-05-04",
        week: "土",
        week_en: "Saturday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2047-05-05": {
        date: "2047-05-05",
        week: "日",
        week_en: "Sunday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2047-05-06": {
        date: "2047-05-06",
        week: "月",
        week_en: "Monday",
        name: "こどもの日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2047-07-15": {
        date: "2047-07-15",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2047-08-11": {
        date: "2047-08-11",
        week: "日",
        week_en: "Sunday",
        name: "山の日",
        name_en: "Mountain Day"
    },
    "2047-08-12": {
        date: "2047-08-12",
        week: "月",
        week_en: "Monday",
        name: "山の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2047-09-16": {
        date: "2047-09-16",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2047-09-23": {
        date: "2047-09-23",
        week: "月",
        week_en: "Monday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2047-10-14": {
        date: "2047-10-14",
        week: "月",
        week_en: "Monday",
        name: "スポーツの日",
        name_en: "Health and Sports Day"
    },
    "2047-11-03": {
        date: "2047-11-03",
        week: "日",
        week_en: "Sunday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2047-11-04": {
        date: "2047-11-04",
        week: "月",
        week_en: "Monday",
        name: "文化の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2047-11-23": {
        date: "2047-11-23",
        week: "土",
        week_en: "Saturday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2048-01-01": {
        date: "2048-01-01",
        week: "水",
        week_en: "Wednesday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2048-01-13": {
        date: "2048-01-13",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2048-02-11": {
        date: "2048-02-11",
        week: "火",
        week_en: "Tuesday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2048-02-23": {
        date: "2048-02-23",
        week: "日",
        week_en: "Sunday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2048-02-24": {
        date: "2048-02-24",
        week: "月",
        week_en: "Monday",
        name: "天皇誕生日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2048-03-20": {
        date: "2048-03-20",
        week: "金",
        week_en: "Friday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2048-04-29": {
        date: "2048-04-29",
        week: "水",
        week_en: "Wednesday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2048-05-03": {
        date: "2048-05-03",
        week: "日",
        week_en: "Sunday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2048-05-04": {
        date: "2048-05-04",
        week: "月",
        week_en: "Monday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2048-05-05": {
        date: "2048-05-05",
        week: "火",
        week_en: "Tuesday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2048-05-06": {
        date: "2048-05-06",
        week: "水",
        week_en: "Wednesday",
        name: "こどもの日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2048-07-20": {
        date: "2048-07-20",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2048-08-11": {
        date: "2048-08-11",
        week: "火",
        week_en: "Tuesday",
        name: "山の日",
        name_en: "Mountain Day"
    },
    "2048-09-21": {
        date: "2048-09-21",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2048-09-22": {
        date: "2048-09-22",
        week: "火",
        week_en: "Tuesday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2048-10-12": {
        date: "2048-10-12",
        week: "月",
        week_en: "Monday",
        name: "スポーツの日",
        name_en: "Health and Sports Day"
    },
    "2048-11-03": {
        date: "2048-11-03",
        week: "火",
        week_en: "Tuesday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2048-11-23": {
        date: "2048-11-23",
        week: "月",
        week_en: "Monday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2049-01-01": {
        date: "2049-01-01",
        week: "金",
        week_en: "Friday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2049-01-11": {
        date: "2049-01-11",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2049-02-11": {
        date: "2049-02-11",
        week: "木",
        week_en: "Thursday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2049-02-23": {
        date: "2049-02-23",
        week: "火",
        week_en: "Tuesday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2049-03-20": {
        date: "2049-03-20",
        week: "土",
        week_en: "Saturday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2049-04-29": {
        date: "2049-04-29",
        week: "木",
        week_en: "Thursday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2049-05-03": {
        date: "2049-05-03",
        week: "月",
        week_en: "Monday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2049-05-04": {
        date: "2049-05-04",
        week: "火",
        week_en: "Tuesday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2049-05-05": {
        date: "2049-05-05",
        week: "水",
        week_en: "Wednesday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2049-07-19": {
        date: "2049-07-19",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2049-08-11": {
        date: "2049-08-11",
        week: "水",
        week_en: "Wednesday",
        name: "山の日",
        name_en: "Mountain Day"
    },
    "2049-09-20": {
        date: "2049-09-20",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2049-09-21": {
        date: "2049-09-21",
        week: "火",
        week_en: "Tuesday",
        name: "休日",
        name_en: "Citizen's Holiday"
    },
    "2049-09-22": {
        date: "2049-09-22",
        week: "水",
        week_en: "Wednesday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2049-10-11": {
        date: "2049-10-11",
        week: "月",
        week_en: "Monday",
        name: "スポーツの日",
        name_en: "Health and Sports Day"
    },
    "2049-11-03": {
        date: "2049-11-03",
        week: "水",
        week_en: "Wednesday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2049-11-23": {
        date: "2049-11-23",
        week: "火",
        week_en: "Tuesday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
    "2050-01-01": {
        date: "2050-01-01",
        week: "土",
        week_en: "Saturday",
        name: "元日",
        name_en: "New Year's Day"
    },
    "2050-01-10": {
        date: "2050-01-10",
        week: "月",
        week_en: "Monday",
        name: "成人の日",
        name_en: "Coming of Age Day"
    },
    "2050-02-11": {
        date: "2050-02-11",
        week: "金",
        week_en: "Friday",
        name: "建国記念の日",
        name_en: "National Foundation Day"
    },
    "2050-02-23": {
        date: "2050-02-23",
        week: "水",
        week_en: "Wednesday",
        name: "天皇誕生日",
        name_en: "Emperor's Birthday"
    },
    "2050-03-20": {
        date: "2050-03-20",
        week: "日",
        week_en: "Sunday",
        name: "春分の日",
        name_en: "Vernal Equinox Day"
    },
    "2050-03-21": {
        date: "2050-03-21",
        week: "月",
        week_en: "Monday",
        name: "春分の日 振替休日",
        name_en: "Holiday in lieu"
    },
    "2050-04-29": {
        date: "2050-04-29",
        week: "金",
        week_en: "Friday",
        name: "昭和の日",
        name_en: "Showa Day"
    },
    "2050-05-03": {
        date: "2050-05-03",
        week: "火",
        week_en: "Tuesday",
        name: "憲法記念日",
        name_en: "Constitution Memorial Day"
    },
    "2050-05-04": {
        date: "2050-05-04",
        week: "水",
        week_en: "Wednesday",
        name: "みどりの日",
        name_en: "Greenery Day"
    },
    "2050-05-05": {
        date: "2050-05-05",
        week: "木",
        week_en: "Thursday",
        name: "こどもの日",
        name_en: "Children's Day"
    },
    "2050-07-18": {
        date: "2050-07-18",
        week: "月",
        week_en: "Monday",
        name: "海の日",
        name_en: "Marine Day"
    },
    "2050-08-11": {
        date: "2050-08-11",
        week: "木",
        week_en: "Thursday",
        name: "山の日",
        name_en: "Mountain Day"
    },
    "2050-09-19": {
        date: "2050-09-19",
        week: "月",
        week_en: "Monday",
        name: "敬老の日",
        name_en: "Respect for the Aged Day"
    },
    "2050-09-23": {
        date: "2050-09-23",
        week: "金",
        week_en: "Friday",
        name: "秋分の日",
        name_en: "Autumnal Equinox Day"
    },
    "2050-10-10": {
        date: "2050-10-10",
        week: "月",
        week_en: "Monday",
        name: "スポーツの日",
        name_en: "Health and Sports Day"
    },
    "2050-11-03": {
        date: "2050-11-03",
        week: "木",
        week_en: "Thursday",
        name: "文化の日",
        name_en: "National Culture Day"
    },
    "2050-11-23": {
        date: "2050-11-23",
        week: "水",
        week_en: "Wednesday",
        name: "勤労感謝の日",
        name_en: "Labor Thanksgiving Day"
    },
};
module.exports = holidays;
